import { ReactComponent as Interactivity } from "../../src/Assets/Images/interactivity.svg";

import { ReactComponent as MentalHealth } from "../../src/Assets/Images/Mental_Health-Icons.svg";
import { ReactComponent as Frame } from "../../src/Assets/Images/Frame_720.svg";
import TeleHealth from "../Assets/Images/Telehealth.svg";
import MentalHealthBank from "../Assets/Images/MentalHealth.svg";
import Nutritionist from "../Assets/Images/Nutritionist.svg";
import AboutUsSection1 from "../Assets/Images/aboutUsIcon1.png";
import AboutUsSection2 from "../Assets/Images/aboutUsIcon2.png";
import AboutUsSection3 from "../Assets/Images/aboutUsIcon3.png";
import redTick from "../Assets/Images/redtickhp.svg";
import greentick from "../Assets/Images/greentickhp.svg";
import greytick from "../Assets/Images/graytickHP.svg";

import { ReactComponent as Objects } from "../Assets/Images/OBJECTS.svg";
import { ReactComponent as TwentyFourSeven } from "../Assets/Images/247.svg";
import { ReactComponent as iambestImage } from "../../src/Assets/Images/am-best.svg";
import consultantIcon from "../../src/Assets/Images/faqs-icon-1.svg";
import ourPlansIcon from "../../src/Assets/Images/faqs-icon-2.svg";
import writingIcon from "../../src/Assets/Images/faqs-icon-3.svg";
import policyIcon from "../../src/Assets/Images/faqs-icon-4.svg";
import paymentIcon from "../../src/Assets/Images/faqs-icon-5.svg";
import policyDocumentIcon from "../../src/Assets/Images/faqs-icon-6.svg";
import clinicalCareIcon from "../../src/Assets/Images/faqs-icon-7.svg";
import travlingIcon from "../../src/Assets/Images/faqs-icon-8.svg";
import portalsIcon from "../../src/Assets/Images/faqs-icon-9.svg";
import supportIcon from "../../src/Assets/Images/faqs-icon-10.png";

import { ReactComponent as Healthcare } from "../Assets/Images/Healthcare_Icons.svg";
import { ReactComponent as ladyImage } from "../../src/Assets/Images/Superior.svg";
import { ReactComponent as healthImage } from "../../src/Assets/Images/Healthcare_Icons.svg";
import promisesImage from "../../src/Assets/Images/promises.png";
export const navArray = [
  {
    name: "About us",
    redirectlink: "/about",
  },
  {
    name: "Products",
    redirectlink: "/products",
  },
  {
    name: "Hospitals",
    redirectlink: "/hopitals",
  },
  {
    name: "AF Care",
    redirectlink: "/af-care",
  },
  {
    name: "Contact Us",
    buttonColor: "primary",
  },
  {
    type: "dropdown",
    dropdownItems: ["English", "Spanish", "French"],
    defaultLabel: "Eng",
  },
];

export const dropdownProps = {
  buttonText: "Contact Us",
  buttonColor: "primary",
  dropdownItems: {
    defaultLabel: "Eng",
    value: ["English", "Spanish", "French"],
  },
};

export const displayText = [
  {
    src: Interactivity,
    headingText: "Telehealth",
    subText: "24/7 video call access to consult with a network of doctors.",
  },
  {
    src: MentalHealth,
    headingText: "Mental Health Coaching",
    subText:
      "Designed to help manage emotions, improve relationship skills, challenge negative thinking, and reduce stress.",
  },
  {
    src: Frame,
    headingText: "Nutritionist",
    subText:
      "Includes nutritionist visits to support your health and manage your weight effectively.",
  },
];

export const customerServiceText = [
  {
    src: Objects,
    headingText: "Medication Management",
    subText:
      "Assistance to deliver specialty medications in U.S. and Latin America.",
  },
  {
    src: TwentyFourSeven,
    headingText: "24/7 Service",
    subText: "Guidance with any medical notifications or services.",
  },
  {
    src: Healthcare,
    headingText: "Second Medical Opinion",
    subText:
      "Online access to worldwide top experts who will provide reassurance about diagnosis and treatment recommendations.",
  },
];

export const medicalOpinion = [
  "Second Medical Opinion",
  "Mental Health Coaching",
  "Telehealth",
  "Convenience Clinics in U.S.",
];

export const seriousAccident = [
  "Serious Accident Hospitalization",
  "Preventive Care Examns",
  "Routing Medical Examniation",
  "Convenience Clinics in U.S.",
  "Funeral Expenses",
  "Eye exam",
];

export const aboutUsAccordionData = [
  {
    id: "1",
    header:
      "How can I apply for a Health Insurance Policy with American Fidelity?",
    body: "string",
    // imageSrc: MentalHealth
  },
  {
    id: "2",
    header:
      "What makes American Fidelity Health Insurance different from other health insurance?",
    body: "string",
  },
  {
    id: "3",
    header: "May I include my family in my Health Insurance Plan?",
    body: "string",
  },
  {
    id: "4",
    header:
      "What is the difference between the different American Fidelity Health Insurance plans?",
    body: "string",
  },
  {
    id: "5",
    header: "How does AF Health use technology to improve my experience?",
    body: "string",
  },
  {
    id: "6",
    header:
      "May I access specialized treatments with American Fidelity Health Insurance Plans?",
    body: "string",
  },
];

export const displayTextDummy = [
  {
    src: Interactivity,
    headingText: "Political and economic stability",
    innerSubText: "USD $1= BBD $2<sup>11</sup>",
  },
  {
    src: MentalHealth,
    headingText: "Transparency",
    innerSubText:
      "Among the top 3 least corrupt countries in the Americas (Transparency International Index)",
  },
  {
    src: Frame,
    headingText: "Convenience",
    innerSubText:
      "Barbados is the chosen jurisdiction for 267 insurance companies",
  },
];
export const healthData = [
  {
    headingText: "Financial strength",
    subText:
      "Since 1982, American Fidelity Assurance Company has consistently earned an “A+” (Superior) rating from AM Best. ",
  },
  {
    headingText: "Long Term Commitment",
    subText:
      "We are backed by more than 60 years of experience and an impeccable reputation.",
  },
  {
    headingText: "Service Excellence",
    subText:
      "We strive to maintain the highest standards and offer first class service to our customers.",
  },
  {
    headingText: "Medical Expertise",
    subText:
      "We provide access to worldwide medical specialists, ensuring you receive the best quality of care anytime you need it. ",
  },
  {
    headingText: "Innovation",
    subText:
      "Our advanced tools offer a seamless user experience, making it easy to manage you policy and access healthcare services.",
  },
];
export const aboutImages = [
  {
    src: ladyImage,
  },
  {
    src: iambestImage,
  },
  {
    src: promisesImage,
  },
  {
    src: healthImage,
  },
];

export const americanGlobalFidelity = [
  {
    icon: AboutUsSection1,
    title: "Political and economic stability",
    points: [
      "USD $1=BBD $2<sup>11</sup>",
      "Member of the British Commonwealth of Nations",
      "Model of Good Governance",
    ],
  },
  {
    icon: AboutUsSection2,
    title: "Transparencey",
    points: [
      "Signatory of FATCA",
      "Among the top 3 least corrupt countries in the American<sup>10</sup>",
    ],
  },
  {
    icon: AboutUsSection3,
    title: "Convenience",
    points: [
      "Easy access to international markets",
      "Efficiency in handling and processing applications",
      "Barbados is the chosen jurisdiction for 267 insurance companies<sup>12</sup>",
    ],
  },
];

export const categoriesEng = [
  { name: "Consultants", icon: consultantIcon },
  { name: "Our Plans", icon: ourPlansIcon },
  { name: "Underwriting", icon: writingIcon },
  { name: "Policy Administration", icon: policyIcon },
  { name: "Premium Payment", icon: paymentIcon },
  { name: "Policy Documents", icon: policyDocumentIcon },
  { name: "Clinical Care", icon: clinicalCareIcon },
  { name: "Traveling to the U.S.", icon: travlingIcon },
  { name: "Portals", icon: portalsIcon }
];
export const categoriesSpanish = [
  { name: "Consultores", icon: consultantIcon },
  { name: "Nuestros Planes", icon: ourPlansIcon },
  { name: "Evaluación De Riesgo", icon: writingIcon },
  { name: "Administración De Pólizas", icon: policyIcon },
  { name: "Pago De La Prima", icon: paymentIcon },
  { name: "Documentos De La Póliza", icon: policyDocumentIcon },
  { name: "Atención Clínica", icon: clinicalCareIcon },
  { name: "Viajar A Ee. Uu.", icon: travlingIcon },
  { name: "Portales", icon: portalsIcon }
];

export const faqs = {
  Consultants: [
    {
      question:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
      answer:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
    },
    {
      question:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
      answer:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
    },
    {
      question:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
      answer:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
    },
  ],
  "Our Plans": [
    {
      question:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
      answer:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
    },
    {
      question:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
      answer:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
    },
    {
      question:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
      answer:
        "How can I become an Affiliated Consultant with American Fidelity Global Solutions Ltd?",
    },
  ],
};

export const hospitalData = [
  {
    "Provider Name": "Baptist Medical Center South",
    City: "Alabaster",
    State: "ALABAMA",
    Zipcode: 36116,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Vincent’s East",
    City: "Vestavia Hills",
    State: "ALABAMA",
    Zipcode: 35235,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Crestwood Medical Center",
    City: "Huntsville",
    State: "ALABAMA",
    Zipcode: 35801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Elmore Community Hospital",
    City: "Wetumpka",
    State: "ALABAMA",
    Zipcode: 36092,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Lakeland Community Hospital",
    City: "Haleyville",
    State: "ALABAMA",
    Zipcode: 35565,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "RMC/JSU Health Center",
    City: "Alexander City",
    State: "ALABAMA",
    Zipcode: 35010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Baptist Medical Center East",
    City: "Montgomery",
    State: "ALABAMA",
    Zipcode: 36117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Prattville Baptist Hospital",
    City: "Prattville",
    State: "ALABAMA",
    Zipcode: 36067,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Flowers Hospital",
    City: "Dothan",
    State: "ALABAMA",
    Zipcode: 36305,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Grandview Medical Center",
    City: "Birmingham",
    State: "ALABAMA",
    Zipcode: 35243,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascension St. Vincent’s Birmingham",
    City: "Birmingham",
    State: "ALABAMA",
    Zipcode: 35205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascencion St. Vincent's Blount",
    City: "Oneonta",
    State: "ALABAMA",
    Zipcode: 35121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Huntsville Hospital",
    City: "Huntsville",
    State: "ALABAMA",
    Zipcode: 35801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jackson Hospital",
    City: "Montgomery",
    State: "ALABAMA",
    Zipcode: 36106,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UAB Medical West",
    City: "Bessemer",
    State: "ALABAMA",
    Zipcode: 35022,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mizell Memorial Hospital",
    City: "Opp",
    State: "ALABAMA",
    Zipcode: 36467,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Springhill Medical Center",
    City: "Mobile",
    State: "ALABAMA",
    Zipcode: 36608,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Callahan Eye Foundation Hospital",
    City: "Birmingham",
    State: "ALABAMA",
    Zipcode: 35233,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Alabama at Birmingham Hospital",
    City: "Birmingham",
    State: "ALABAMA",
    Zipcode: 35233,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "USA Health University Hospital",
    City: "Mobile",
    State: "ALABAMA",
    Zipcode: 36617,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Alaska Regional Hospital",
    City: "Anchorage",
    State: "ALASKA",
    Zipcode: 99508,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bartlett Regional Hospital",
    City: "Juneau",
    State: "ALASKA",
    Zipcode: 99801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Central Peninsula General Hospital",
    City: "Soldotna",
    State: "ALASKA",
    Zipcode: 99669,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "South Peninsula Hospital Inc",
    City: "Homer",
    State: "ALASKA",
    Zipcode: 99603,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Searhc Wrangell Medical Center",
    City: "Wrangell",
    State: "ALASKA",
    Zipcode: 99929,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Arizona General Hospital ",
    City: "Mesa ",
    State: "ARIZONA",
    Zipcode: 85204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Abrazo Scottsdale Campus",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85032,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Goldfield Medical Center",
    City: "Apache Junction",
    State: "ARIZONA",
    Zipcode: 85120,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Casa Grande Medical Center",
    City: "Casa Grande",
    State: "ARIZONA",
    Zipcode: 85122,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Gateway Medical Center",
    City: "Gilbert",
    State: "ARIZONA",
    Zipcode: 85234,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Thunderbird Medical Center",
    City: "Glendale",
    State: "ARIZONA",
    Zipcode: 85306,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Banner Desert Medical Center",
    City: "Mesa",
    State: "ARIZONA",
    Zipcode: 85202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Baywood Medical Center",
    City: "Mesa",
    State: "ARIZONA",
    Zipcode: 85206,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Banner Heart Hospital",
    City: "Mesa",
    State: "ARIZONA",
    Zipcode: 85206,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Banner Univ Medical Center Phoenix Campus",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85006,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Banner University Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85006,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Banner Estrella Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85037,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Banner Ironwood Medical Center",
    City: "Queen Creek",
    State: "ARIZONA",
    Zipcode: 85140,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Boswell Medical Center",
    City: "Sun City",
    State: "ARIZONA",
    Zipcode: 85351,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Banner Del E. Webb Medical Center",
    City: "Sun City West",
    State: "ARIZONA",
    Zipcode: 85375,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Carondelet Health Network",
    City: "Tucson",
    State: "ARIZONA",
    Zipcode: 85742,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Chandler Regional Medical Center ",
    City: "Chandler ",
    State: "ARIZONA",
    Zipcode: 85224,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "NorthWest Medical Center",
    City: "Tucson",
    State: "ARIZONA",
    Zipcode: 85741,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HonorHealth John C. Lincoln Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85020,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HonorHealth Scottsdale Healthcare Osborn Medical Center",
    City: "Scottsdale",
    State: "ARIZONA",
    Zipcode: 85251,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "HonorHealth Scottsdale Thompson Peak Medical Center",
    City: "Scottsdale",
    State: "ARIZONA",
    Zipcode: 85255,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "HonorHealth Scottsdale Healthcare Shea Medical Center",
    City: "Scottsdale",
    State: "ARIZONA",
    Zipcode: 85260,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mayo Clinic",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85054,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Temple St. Lukes Hospital ",
    City: "Temple ",
    State: "ARIZONA",
    Zipcode: 85281,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Tucson Medical Center",
    City: "Tucson",
    State: "ARIZONA",
    Zipcode: 85712,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valleywise Comm Health Center - McDowell",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85004,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name":
      "Valleywise Community Health Center - South Central Phoenix",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85041,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Phoenix Children's Hospital",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Joseph’s Hospital and Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85013,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valleywise Community Health Center - North Phoenix",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85021,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valleywise Community Health Center - Maryvale",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valleywise Emergency - Maryvale",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85031,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valleywise Health Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85008,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name":
      "Valleywise Community Health Center - South Phoenix / Laveen",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85041,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valleywise Comprehensive Health Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85008,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Valleywise Community Health Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85041,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St.Vincent Medical Center North",
    City: "Little Rock",
    State: "ARKANSAS",
    Zipcode: 72117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "National Park Medical Center",
    City: "Hot Springs",
    State: "ARKANSAS",
    Zipcode: 71901,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Arkansas Childrens Hospital",
    City: "Little Rock",
    State: "ARKANSAS",
    Zipcode: 72202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Arkansas Surgical Hospital",
    City: "North Little Rock",
    State: "ARKANSAS",
    Zipcode: 72118,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Health Medical Center",
    City: "Conway",
    State: "ARKANSAS",
    Zipcode: 72032,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Baptist Health Fort Smith",
    City: "Fort Smith",
    State: "ARKANSAS",
    Zipcode: 72901,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "NEA Baptist Memorial Hospital",
    City: "Jonesboro",
    State: "ARKANSAS",
    Zipcode: 72117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Health Medical Center - North Little Rock",
    City: "North Little Rock",
    State: "ARKANSAS",
    Zipcode: 72117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "CHI St. Vincent Hot Springs",
    City: "Hot Springs ",
    State: "ARKANSAS",
    Zipcode: 71913,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHI St. Vincent Infirmary",
    City: "Little Rock",
    State: "ARKANSAS",
    Zipcode: 72205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHI St. Vincent North Hospital",
    City: "Sherwood",
    State: "ARKANSAS",
    Zipcode: 72120,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mercy Hospital Fort Smith",
    City: "Fort Smith",
    State: "ARKANSAS",
    Zipcode: 72903,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Arkansas Methodist Medical Center",
    City: "Paragould",
    State: "ARKANSAS",
    Zipcode: 72450,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Siloam Springs Regional Hospital",
    City: "Fayetteville",
    State: "ARKANSAS",
    Zipcode: 72701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Arkansas for Medical Sciences (UAMS)",
    City: "Little Rock",
    State: "ARKANSAS",
    Zipcode: 72205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Unity Health - Jacksonville",
    City: "Jacksonville",
    State: "ARKANSAS",
    Zipcode: 72076,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Washington Regional Medical Center",
    City: "Fayetteville",
    State: "ARKANSAS",
    Zipcode: 72703,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Centinela Medical Center Clinic",
    City: "Inglewood",
    State: "CALIFORNIA",
    Zipcode: 90301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Eisenhower Medical Center",
    City: "Cathedral City",
    State: "CALIFORNIA",
    Zipcode: 92234,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Alvarado Hospital LLC",
    City: "San Diego",
    State: "CALIFORNIA",
    Zipcode: 92120,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "USC Norris Comprehensive Cancer Center",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Rady Children's Hospital",
    City: "Solana Beach",
    State: "CALIFORNIA",
    Zipcode: 92075,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Good Samaritan Hospital",
    City: "San Jose",
    State: "CALIFORNIA",
    Zipcode: 95124,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UC San Diego Medical Center",
    City: "La Jolla",
    State: "CALIFORNIA",
    Zipcode: 92037,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of California San Diego Medical Center",
    City: "San Diego",
    State: "CALIFORNIA",
    Zipcode: 92103,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Loma Linda University Medical Center ",
    City: "Loma Linda ",
    State: "CALIFORNIA",
    Zipcode: 92354,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Los Robles Hospital ",
    City: "Thousands Oaks ",
    State: "CALIFORNIA",
    Zipcode: 91360,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Santa Clara Valley Medical Center",
    City: "San Jose",
    State: "CALIFORNIA",
    Zipcode: 95128,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Stanford Medical Center ",
    City: "Stanford ",
    State: "CALIFORNIA",
    Zipcode: 94305,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "USC Verdugo Hills Hospital ",
    City: "Glendale",
    State: "CALIFORNIA",
    Zipcode: 91208,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "White Memorial Medical Center",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Cedar Sinai Medical Center",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90048,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Children’s Hospital Los Angeles",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90027,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHOC Children's Hospital",
    City: "Orange",
    State: "CALIFORNIA",
    Zipcode: 92868,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "City of Hope Comprehensive Cancer Center",
    City: "Duarte",
    State: "CALIFORNIA",
    Zipcode: 91010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Dameron Hospital",
    City: "Stockton",
    State: "CALIFORNIA",
    Zipcode: 95203,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Desert Regional Medical Center ",
    City: "Palm Springs",
    State: "CALIFORNIA",
    Zipcode: 92262,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "St. Mary’s Hospital and Medical Center",
    City: "Long Beach",
    State: "CALIFORNIA",
    Zipcode: 90813,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "French Hospital Medical",
    City: "San Luis Obispo",
    State: "CALIFORNIA",
    Zipcode: 93401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Garden Grove Hospital and Medical Center",
    City: "Garden Grove",
    State: "CALIFORNIA",
    Zipcode: 92843,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hoag Orthopedic Institute",
    City: "Irvine",
    State: "CALIFORNIA",
    Zipcode: 92618,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "CHA Hollywood Presbyterian Medical Center",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90027,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Huntington Hospital",
    City: "Pasadena",
    State: "CALIFORNIA",
    Zipcode: 91105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "John Muir Medical Center - Walnut Creek",
    City: "Walnut Creek",
    State: "CALIFORNIA",
    Zipcode: 94598,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Keck Hospital of USC",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Saddleback Memorial Medical Center",
    City: "Laguna Hills",
    State: "CALIFORNIA",
    Zipcode: 92653,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Long Beach Memorial Medical Center",
    City: "Long Beach",
    State: "CALIFORNIA",
    Zipcode: 90806,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Memorial Hospital of Gardena",
    City: "Gardena",
    State: "CALIFORNIA",
    Zipcode: 90247,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "PIH Health Hospital",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90017,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Providence St. Joseph Medical Center",
    City: "Burbank",
    State: "CALIFORNIA",
    Zipcode: 91505,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Providence Little Company of Mary Medical Center",
    City: "Torrance",
    State: "CALIFORNIA",
    Zipcode: 90503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "San Antonio Regional Hospital",
    City: "Upland",
    State: "CALIFORNIA",
    Zipcode: 91786,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Scripps Mercy Hospital Chula Vista",
    City: "Chula Vista",
    State: "CALIFORNIA",
    Zipcode: 91910,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Scripps Memorial Hospital Encinitas",
    City: "Encinitas",
    State: "CALIFORNIA",
    Zipcode: 92024,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Scripps Green Hospital",
    City: "La Jolla",
    State: "CALIFORNIA",
    Zipcode: 92037,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Scripps Memorial Hospital La Jolla",
    City: "La Jolla",
    State: "CALIFORNIA",
    Zipcode: 92037,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Sharp Chula Vista Medical Center",
    City: "Chula Vista",
    State: "CALIFORNIA",
    Zipcode: 91911,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sharp Mary Birch Hospital for Women & Newborns",
    City: "San Diego",
    State: "CALIFORNIA",
    Zipcode: 92123,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Sharp Memorial Hospital",
    City: "San Diego",
    State: "CALIFORNIA",
    Zipcode: 92123,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Lucile Packard Children's Hospital Stanford",
    City: "Palo Alto",
    State: "CALIFORNIA",
    Zipcode: 94304,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Saint Francis Memorial Hospital",
    City: "Lynwood",
    State: "CALIFORNIA",
    Zipcode: 90262,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Sutter Auburn Faith Hospital",
    City: "Auburn",
    State: "CALIFORNIA",
    Zipcode: 95602,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Sutter Davis Hospital",
    City: "Davis",
    State: "CALIFORNIA",
    Zipcode: 95616,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Sutter Roseville Medical Center",
    City: "Roseville",
    State: "CALIFORNIA",
    Zipcode: 95661,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UCSF Medical Center",
    City: "San Francisco",
    State: "CALIFORNIA",
    Zipcode: 94143,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Watsonville Community Hospital",
    City: "Watsonville",
    State: "CALIFORNIA",
    Zipcode: 95076,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Chinese Hospital",
    City: "San Francisco",
    State: "CALIFORNIA",
    Zipcode: 94133,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Scripps Mercy Hospital San Diego",
    City: "San Diego",
    State: "CALIFORNIA",
    Zipcode: 92103,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sutter Medical Center",
    City: "Sacramento",
    State: "CALIFORNIA",
    Zipcode: 95816,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UCI Medical Center",
    City: "Orange",
    State: "CALIFORNIA",
    Zipcode: 92868,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Presbyterian St. Luke’s Medical Center",
    City: "Denver",
    State: "COLORADO",
    Zipcode: 80218,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Medical Center of Aurora",
    City: "Aurora",
    State: "COLORADO",
    Zipcode: 80011,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Rose Medical Center",
    City: "Denver",
    State: "COLORADO",
    Zipcode: 80220,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Swedish Medical Center",
    City: "Englewood",
    State: "COLORADO",
    Zipcode: 80113,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Sky Ridge Medical Center",
    City: "Lone Tree",
    State: "COLORADO",
    Zipcode: 80124,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Suburban Medical Center",
    City: "Thornton",
    State: "COLORADO",
    Zipcode: 80229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Exempla Saint Joseph Hospital",
    City: "Denver",
    State: "COLORADO",
    Zipcode: 80218,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Exempla Lutheran Medical Center",
    City: "Wheat Ridge",
    State: "COLORADO",
    Zipcode: 80033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Rio Grande Hospital Clinic",
    City: "Del Norte",
    State: "COLORADO",
    Zipcode: 81132,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Parker Adventist Hospital",
    City: "Aurora",
    State: "COLORADO",
    Zipcode: 80016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Thomas More Hospital",
    City: "Canon City",
    State: "COLORADO",
    Zipcode: 81212,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Castle Rock Adventist Hospitals",
    City: "Castle Rock",
    State: "COLORADO",
    Zipcode: 80109,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Anthony Summit Hospital",
    City: "Frisco",
    State: "COLORADO",
    Zipcode: 80443,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Littleton Adventist Hospital",
    City: "Littleton",
    State: "COLORADO",
    Zipcode: 80122,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Avista Adventist Hospital",
    City: "Louisville",
    State: "COLORADO",
    Zipcode: 80027,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Porter Adventist Hospital",
    City: "Louisville",
    State: "COLORADO",
    Zipcode: 80210,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Anthony North Hospital",
    City: "Westminster",
    State: "COLORADO",
    Zipcode: 80031,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Children's Hospital Colorado",
    City: "Aurora",
    State: "COLORADO",
    Zipcode: 80045,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Penrose Hospital",
    City: "Colorado Springs",
    State: "COLORADO",
    Zipcode: 80907,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Francis Medical Center",
    City: "Colorado Springs",
    State: "COLORADO",
    Zipcode: 80923,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Mary Corwin Hospital",
    City: "Pueblo",
    State: "COLORADO",
    Zipcode: 81004,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Saint Joseph Hospital",
    City: "Louisville",
    State: "COLORADO",
    Zipcode: 80233,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UCHealth University of Colorado Hospital",
    City: "Boulder",
    State: "COLORADO",
    Zipcode: 80303,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UCHealth Memorial Hospital Central",
    City: "Colorado Springs",
    State: "COLORADO",
    Zipcode: 80909,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "UCHealth Memorial Hospital North",
    City: "Colorado Springs",
    State: "COLORADO",
    Zipcode: 80920,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bridgeport Hospital Milford Campus",
    City: "Milford",
    State: "CONNECTICUT",
    Zipcode: 6460,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Danbury Hospital",
    City: "Ridgefield",
    State: "CONNECTICUT",
    Zipcode: 6877,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mercy Medical Center Redding",
    City: "Milford",
    State: "CONNECTICUT",
    Zipcode: 6461,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Gaylord Hospital",
    City: "North Haven",
    State: "CONNECTICUT",
    Zipcode: 6473,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Griffin Hospital",
    City: "Shelton",
    State: "CONNECTICUT",
    Zipcode: 6418,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Stamford Hospital",
    City: "Norwalk",
    State: "CONNECTICUT",
    Zipcode: 6851,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Francis Hospital ",
    City: "Hartford",
    State: "CONNECTICUT",
    Zipcode: 6105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Marys Hospital",
    City: "Naugatuck",
    State: "CONNECTICUT",
    Zipcode: 6770,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Waterbury Hospital/healthy Hearts",
    City: "Waterbury",
    State: "CONNECTICUT",
    Zipcode: 6702,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Yale New Haven Health System",
    City: "Milford",
    State: "CONNECTICUT",
    Zipcode: 6460,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Yale New Haven Hospital",
    City: "Sebastian",
    State: "CONNECTICUT",
    Zipcode: 6510,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Greenwich Hospital",
    City: "Stamford",
    State: "CONNECTICUT",
    Zipcode: 6902,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Yale New Haven Hospital, Saint Raphael Campus",
    City: "New Haven",
    State: "CONNECTICUT",
    Zipcode: 6511,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Bayhealth Hospital- Kent Campus",
    City: "Dover",
    State: "DELAWARE",
    Zipcode: 19904,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Nemours Children's Hospital, Delaware",
    City: "Wilmington",
    State: "DELAWARE",
    Zipcode: 19802,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Memorial Cardiac and Vascular Institute",
    City: "Aventura",
    State: "FLORIDA",
    Zipcode: 33021,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Jackson Heart Institute",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "BHW Women's Diagnostic",
    City: "Broward",
    State: "FLORIDA",
    Zipcode: 33326,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "North Shore Medical Center FMC campus",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33313,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Keralty Hospital Miami ",
    City: "Westchester",
    State: "FLORIDA",
    Zipcode: 33155,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mercy Hospital Campus of PGH",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33133,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Miami Transplant Institute",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Outpatient Center of Boynton Beach",
    City: "Boynton Beach",
    State: "FLORIDA",
    Zipcode: 33435,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Holtz Children’s Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Christine E. Lynn Rehabilitation Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Advent-Health Daytona Beach.",
    City: "Daytona Beach",
    State: "FLORIDA",
    Zipcode: 32117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name":
      "Bascom Palmer Eye Institute - Anne Bates Leach Eye Hospital",
    City: "Coral Gables",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bayfront Health Port Charlotte",
    City: "Venice",
    State: "FLORIDA",
    Zipcode: 33952,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bethesda Hospital East and West",
    City: "Boynton Beach",
    State: "FLORIDA",
    Zipcode: 33435,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Cypress Creek Outpatient Surgical Center",
    City: "Broward",
    State: "FLORIDA",
    Zipcode: 33309,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Aventura Kidney Center ",
    City: "Halandale Beach",
    State: "FLORIDA",
    Zipcode: 33009,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Good Samaritan Medical Center",
    City: "West Palm Beach",
    State: "FLORIDA",
    Zipcode: 33401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Doctors Hospital",
    City: "Coral Gables",
    State: "FLORIDA",
    Zipcode: 33146,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Homestead Hospital",
    City: "Homestead",
    State: "FLORIDA",
    Zipcode: 33033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Fishermen’s Community Hospital",
    City: "Marathon",
    State: "FLORIDA",
    Zipcode: 33050,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "West Kendall Baptist Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33186,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "South Miami Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33143,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33176,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Mariners Hospital",
    City: "Tavernier",
    State: "FLORIDA",
    Zipcode: 33070,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bartow Regional Medical Center",
    City: "Bartow",
    State: "FLORIDA",
    Zipcode: 33830,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Morton Plant Hospital",
    City: "Clearwater",
    State: "FLORIDA",
    Zipcode: 33756,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mease Dunedin Hospital",
    City: "Dunedin",
    State: "FLORIDA",
    Zipcode: 34698,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Morton Plant North Bay Hospital",
    City: "New Port Richey",
    State: "FLORIDA",
    Zipcode: 34652,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mease Countryside Hospital",
    City: "Safety Harbor",
    State: "FLORIDA",
    Zipcode: 34695,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Joseph’s Hospital",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33607,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "HCA Florida Englewood Hospital",
    City: "Englewood",
    State: "FLORIDA",
    Zipcode: 34223,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascension St. Vincent ",
    City: "Jacksonville",
    State: "FLORIDA",
    Zipcode: 32225,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Larkin Community Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33143,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mercy Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33133,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "H. Lee Moffitt Cancer Center and Research Institute",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33612,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Cleveland Clinic Florida",
    City: "Parkland",
    State: "FLORIDA",
    Zipcode: 33331,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Surgery Center of Aventura",
    City: "Aventura",
    State: "FLORIDA",
    Zipcode: 33180,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Surgical Park Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33156,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Miami Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Florida Hospital-Apopka",
    City: "Apopka",
    State: "FLORIDA",
    Zipcode: 32703,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "AdventHealth Heart of Florida",
    City: "Davenport",
    State: "FLORIDA",
    Zipcode: 33837,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth Celebration",
    City: "Kissimmee",
    State: "FLORIDA",
    Zipcode: 34747,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth Lake Wales",
    City: "Lake Wales",
    State: "FLORIDA",
    Zipcode: 33853,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth Orlando",
    City: "Orlando",
    State: "FLORIDA",
    Zipcode: 32803,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth East Orlando",
    City: "Orlando",
    State: "FLORIDA",
    Zipcode: 32822,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth Tampa",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33613,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth North Pinellas",
    City: "Tarpon Springs",
    State: "FLORIDA",
    Zipcode: 34689,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AdventHealth Winter Park",
    City: "Winter Park",
    State: "FLORIDA",
    Zipcode: 32792,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "AdventHealth Zephyrhills",
    City: "Zephyrhills",
    State: "FLORIDA",
    Zipcode: 33541,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Wolfson Children's Hospital",
    City: "Jacksonville",
    State: "FLORIDA",
    Zipcode: 32207,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bayfront Health ",
    City: "Pinellas Park",
    State: "FLORIDA",
    Zipcode: 33782,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Broward Health Coral Springs",
    City: "Coral Springs",
    State: "FLORIDA",
    Zipcode: 33065,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Broward Health North",
    City: "Deerfield Beach",
    State: "FLORIDA",
    Zipcode: 33064,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Broward General Medical Center",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33316,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Broward Health Medical Center",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33316,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Broward Health Imperial Point",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33308,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Boca Raton Regional Hospital",
    City: "Boca Raton",
    State: "FLORIDA",
    Zipcode: 33486,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Coral Gables Hospital",
    City: "Coral Gables",
    State: "FLORIDA",
    Zipcode: 33134,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Delray Medical Center ",
    City: "Delray beach",
    State: "FLORIDA",
    Zipcode: 33484,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Gulf Breeze Hospital",
    City: "Gulf Breeze",
    State: "FLORIDA",
    Zipcode: 32561,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Flagler Hospital",
    City: "Saint Agustine",
    State: "FLORIDA",
    Zipcode: 32086,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Aventura Hospital Medical Center",
    City: "Aventura",
    State: "FLORIDA",
    Zipcode: 33180,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Blake Hospital",
    City: "Bradenton",
    State: "FLORIDA",
    Zipcode: 34209,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida Brandon Hospital",
    City: "Brandon",
    State: "FLORIDA",
    Zipcode: 33511,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Oak Hill Hospital",
    City: "Brookesville",
    State: "FLORIDA",
    Zipcode: 34613,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lawnwood Regional Medical Center",
    City: "Fort Pierce",
    State: "FLORIDA",
    Zipcode: 34950,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Florida Regional Medical Center",
    City: "Gainesville",
    State: "FLORIDA",
    Zipcode: 32605,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida Memorial Hospital",
    City: "Jacksonville",
    State: "FLORIDA",
    Zipcode: 32216,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida Poinciana Hospital",
    City: "Kissimmee",
    State: "FLORIDA",
    Zipcode: 34759,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida Osceola Hospital",
    City: "Kissimmee",
    State: "FLORIDA",
    Zipcode: 34741,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida Northwest Hospital",
    City: "Margate",
    State: "FLORIDA",
    Zipcode: 33063,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kendall Regional Medical Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33175,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida Ocala Hospital",
    City: "Ocala",
    State: "FLORIDA",
    Zipcode: 34471,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida West Hospital",
    City: "Pensacola",
    State: "FLORIDA",
    Zipcode: 32514,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Westside Regional Medical Center",
    City: "Plantation",
    State: "FLORIDA",
    Zipcode: 33324,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida South Tampa Hospital",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33609,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida West Tampa Hospital",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33615,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida JFK Hospital",
    City: "West Palm Beach",
    State: "FLORIDA",
    Zipcode: 33407,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Florida JFK North Hospital",
    City: "West Palm Beach",
    State: "FLORIDA",
    Zipcode: 33408,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascension Sacred Heart ",
    City: "Panama City ",
    State: "FLORIDA",
    Zipcode: 32401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Ascension Sacred Heart Pensacola",
    City: "Pensacola",
    State: "FLORIDA",
    Zipcode: 32504,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Holy Cross Hospital",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33308,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Johns Hopkins All Children’s Hospital",
    City: "Saint Petersburg",
    State: "FLORIDA",
    Zipcode: 33701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jackson Memorial Perdue Medical Center",
    City: "Cutler Bay",
    State: "FLORIDA",
    Zipcode: 33157,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jackson Memorial Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jackson North Medical Center",
    City: "North Miami Beach",
    State: "FLORIDA",
    Zipcode: 33169,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jupiter Medical Center",
    City: "Jupiter",
    State: "FLORIDA",
    Zipcode: 33458,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kindred Hospital South Florida",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33020,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kindred Hospital North Florida",
    City: "Green Cove Springs",
    State: "FLORIDA",
    Zipcode: 32043,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kindred Hospital South Florida - Hollywood",
    City: "Hollywood",
    State: "FLORIDA",
    Zipcode: 33020,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kindred Hospital Bay Area - St. Petersburg",
    City: "Saint Petersburg",
    State: "FLORIDA",
    Zipcode: 33705,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Lakewood Ranch Medical Center",
    City: "Manatee",
    State: "FLORIDA",
    Zipcode: 34202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Manatee Memorial Hospital",
    City: "Bradenton",
    State: "FLORIDA",
    Zipcode: 34208,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mayo Clinic ",
    City: "Jacksonville",
    State: "FLORIDA",
    Zipcode: 32224,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Miami Hand Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33176,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Miami Surgical Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33173,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Sinai Medical Center",
    City: "Miami Beach",
    State: "FLORIDA",
    Zipcode: 33140,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Naples Community Hospital Miramar",
    City: "Naples",
    State: "FLORIDA",
    Zipcode: 34102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Nicklaus Childrens Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33137,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "North Shore Medical Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33150,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Orlando Health Dr. P. Phillips Hospital",
    City: "Orlando",
    State: "FLORIDA",
    Zipcode: 32819,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Palmetto General Hospital",
    City: "Hialeah",
    State: "FLORIDA",
    Zipcode: 33016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Palm Beach Gardens Medical Center",
    City: "Palm Beach Gardens",
    State: "FLORIDA",
    Zipcode: 33410,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sarasota Memorial Hospital",
    City: "Sarasota",
    State: "FLORIDA",
    Zipcode: 34239,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Orlando Health South Lake Hospital",
    City: "Clermont",
    State: "FLORIDA",
    Zipcode: 34711,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Tampa General Hospital",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33606,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "ShorePoint Health Venice",
    City: "Venice",
    State: "FLORIDA",
    Zipcode: 34285,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "West Boca Medical Center ",
    City: "Boca Raton ",
    State: "FLORIDA",
    Zipcode: 33428,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jackson Behavioral Health Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jackson South Medical Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33157,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Palm Springs General Hospital",
    City: "Hialeah",
    State: "FLORIDA",
    Zipcode: 33012,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Halifax Health Medical Center of Daytona",
    City: "Daytona Beach",
    State: "FLORIDA",
    Zipcode: 32114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Regional Hospital Broward",
    City: "Hollywood",
    State: "FLORIDA",
    Zipcode: 33021,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Arnold Palmer Hospital For Children's",
    City: "Orlando",
    State: "FLORIDA",
    Zipcode: 32806,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bayfront Health St. Petersburg",
    City: "Saint Petersburg",
    State: "FLORIDA",
    Zipcode: 33701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Petersburg General Hospital",
    City: "St. Petersburg",
    State: "FLORIDA",
    Zipcode: 33710,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sylvester Comprehensive Cancer Center",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33176,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "The Women’s Center | Jackson South",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33157,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Weston Outpatient Surgical",
    City: "Broward",
    State: "FLORIDA",
    Zipcode: 33326,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Largo Medical Center",
    City: "Largo",
    State: "FLORIDA",
    Zipcode: 33770,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lee Health Coconut Point",
    City: "Estero",
    State: "FLORIDA",
    Zipcode: 34135,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Wellington Regional Medical Center",
    City: "Wellington",
    State: "FLORIDA",
    Zipcode: 33414,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Glancy Rehabilitation Center",
    City: "Gwinnett",
    State: "GEORGIA",
    Zipcode: 30096,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Good Samaritan Health Center",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30318,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Doctors Hospital of Augusta",
    City: "Augusta",
    State: "GEORGIA",
    Zipcode: 30909,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Effingham Hospital",
    City: "Rincon",
    State: "GEORGIA",
    Zipcode: 31326,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Emory University Hospital",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30322,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Emory Decatur Hospital(Dekalb Medical Center)",
    City: "Decatur",
    State: "GEORGIA",
    Zipcode: 30033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Houston Medical Center",
    City: "Warner Robins",
    State: "GEORGIA",
    Zipcode: 31093,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Northside Hospital Atlanta",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30342,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Piedmont Atlanta Hospital",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30309,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Piedmont Augusta Hospital",
    City: "Augusta",
    State: "GEORGIA",
    Zipcode: 30901,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Coliseum Northside Hospital",
    City: "Macon",
    State: "GEORGIA",
    Zipcode: 31210,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Josephs Hospital ",
    City: "Savannah",
    State: "GEORGIA",
    Zipcode: 31419,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Candler Hospital",
    City: "Savannah",
    State: "GEORGIA",
    Zipcode: 31405,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Health University Medical Center",
    City: "Savannah",
    State: "GEORGIA",
    Zipcode: 31404,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Childrens Healthcare of Atlanta",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30345,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Children's Healthcare of Atlanta",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30346,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Emory Saint Joseph’s Hospital",
    City: "Atlanta",
    State: "GEORGIA",
    Zipcode: 30342,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Northside Hospital Gwinnett",
    City: "Lawrenceville",
    State: "GEORGIA",
    Zipcode: 30046,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Wellstar Kennestone Hospital",
    City: "Marietta",
    State: "GEORGIA",
    Zipcode: 30060,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Adventist Health Castle",
    City: "Laie",
    State: "HAWAII",
    Zipcode: 96762,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Pali Momi Medical Center",
    City: "Aiea",
    State: "HAWAII",
    Zipcode: 96701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Straub Medical Center",
    City: "Honolulu",
    State: "HAWAII",
    Zipcode: 96813,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kuakini Medical Center",
    City: "Honolulu",
    State: "HAWAII",
    Zipcode: 96817,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lanai Community Hospital",
    City: "Lanai City",
    State: "HAWAII",
    Zipcode: 96763,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "The Queen's Medical Center",
    City: "Honolulu",
    State: "HAWAII",
    Zipcode: 96817,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Shriners Hospitals For Children",
    City: "Honolulu",
    State: "HAWAII",
    Zipcode: 96826,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Samuel Mahelona Memorial Hospital",
    City: "Kapaa",
    State: "HAWAII",
    Zipcode: 96746,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Molokai General Hospital",
    City: "Kaunakakai",
    State: "HAWAII",
    Zipcode: 96748,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mountain View Hospital",
    City: "Idaho Falls",
    State: "IDAHO",
    Zipcode: 83404,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Madison Memorial Hospital",
    City: "Rexburg",
    State: "IDAHO",
    Zipcode: 83440,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Tri-state Memorial Hospital",
    City: "Clarkston",
    State: "IDAHO",
    Zipcode: 99403,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "West Valley Medical Center Inc",
    City: "Caldwell",
    State: "IDAHO",
    Zipcode: 83605,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Grove Creek Medical Center",
    City: "Blackfoot",
    State: "IDAHO",
    Zipcode: 83221,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Kootenai Health",
    City: "Post Falls",
    State: "IDAHO",
    Zipcode: 83854,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Saint Alphonsus Nampa",
    City: "Nampa",
    State: "IDAHO",
    Zipcode: 83687,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St.Joseph Hospital",
    City: "Lewiston",
    State: "IDAHO",
    Zipcode: 83501,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Lukes Magic Valley Rmc Ltd",
    City: "Twin Falls",
    State: "IDAHO",
    Zipcode: 83301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Treasure Valley Hospital",
    City: "Boise",
    State: "IDAHO",
    Zipcode: 83704,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Walter Knox Memorial Hospital",
    City: "Boise",
    State: "IDAHO",
    Zipcode: 83617,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Saint Alphonsus Regional Medical Center",
    City: "Boise",
    State: "IDAHO",
    Zipcode: 83706,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Alphonsus Reg Medical Center",
    City: "Eagle",
    State: "IDAHO",
    Zipcode: 83707,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Northwest Specialty Hospital",
    City: "Post Falls",
    State: "IDAHO",
    Zipcode: 83854,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Crossroads Community Hospital",
    City: "Jefferson",
    State: "ILLINOIS",
    Zipcode: 62864,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "AMITA Health Saint Joseph Hospital Chicago",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60622,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name":
      "AMITA Health Saints Mary and Elizabeth Medical Center Chicago",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60622,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Presence Saint Joseph Hospital ",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60435,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "AMITA Health Resurrection Medical Center",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60631,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "AMITA Health Saint Joseph Medical Center",
    City: "Joliet",
    State: "ILLINOIS",
    Zipcode: 60435,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Mary’s Hospital Kankakee",
    City: "Kankakee",
    State: "ILLINOIS",
    Zipcode: 60901,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Springfield Memorial Hospital",
    City: "Springfield",
    State: "ILLINOIS",
    Zipcode: 62781,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Advocate Good Shepherd Hospital",
    City: "Barrington",
    State: "ILLINOIS",
    Zipcode: 60010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Advocate Trinity Hospital",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60617,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Advocate Good Samaritan Hospital",
    City: "Downers Grove",
    State: "ILLINOIS",
    Zipcode: 60515,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Advocate Christ Medical Center",
    City: "Oak Lawn",
    State: "ILLINOIS",
    Zipcode: 60453,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Advocate Lutheran General Hospital",
    City: "Park Ridge",
    State: "ILLINOIS",
    Zipcode: 60068,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "AMITA Health Mercy Medical Center Aurora",
    City: "Aurora",
    State: "ILLINOIS",
    Zipcode: 60506,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Edward Hospital - Main Campus",
    City: "Naperville",
    State: "ILLINOIS",
    Zipcode: 60540,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ann & Robert H. Lurie Children’s Hospital of Chicago",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60611,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Northwestern Memorial Hospital",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60611,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Evanston Hospital ",
    City: "Evanston ",
    State: "ILLINOIS",
    Zipcode: 60201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "OSF Sacred Heart Medical Center",
    City: "Danville",
    State: "ILLINOIS",
    Zipcode: 61832,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Rush University Medical Center",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60612,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Thorek Memorial Hospital",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60613,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Chicago",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60637,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Swedish Hospital",
    City: "Illinois",
    State: "ILLINOIS",
    Zipcode: 60625,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital of Chicago",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60640,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "University of Illinois Hospital",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60612,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Shore Hospital System",
    City: "Evanston",
    State: "ILLINOIS",
    Zipcode: 60201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Deaconess Midtown Hospital",
    City: "Evansville",
    State: "INDIANA",
    Zipcode: 47710,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascension St. Vincent Warrick",
    City: "Boonville",
    State: "INDIANA",
    Zipcode: 47601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Vincent Evansville",
    City: "Evansville",
    State: "INDIANA",
    Zipcode: 47714,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Indiana Spine Hospital",
    City: "Carmel",
    State: "INDIANA",
    Zipcode: 46032,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Beacon Granger Hospital at Memorial Hospital",
    City: "South Bend",
    State: "INDIANA",
    Zipcode: 46601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Community Hospital South",
    City: "Indianapolis",
    State: "INDIANA",
    Zipcode: 46227,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Eskenazi Health",
    City: "Indianapolis",
    State: "INDIANA",
    Zipcode: 46202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kindred Hospital-indianapolis",
    City: "Indianapolis",
    State: "INDIANA",
    Zipcode: 46222,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Lutheran Downtown Hospital",
    City: "Fort Wayne",
    State: "INDIANA",
    Zipcode: 46802,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Parkview North Hospital",
    City: "Fort Wayne",
    State: "INDIANA",
    Zipcode: 46845,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Riley Hospital for Children at IU Health",
    City: "Indianapolis",
    State: "INDIANA",
    Zipcode: 46202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Dupont Hospital",
    City: "Fort Wayne",
    State: "INDIANA",
    Zipcode: 46825,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "IU Health Methodist Hospital",
    City: "Indianapolis",
    State: "INDIANA",
    Zipcode: 46202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Indiana University Health",
    City: "Indianapolis",
    State: "INDIANA",
    Zipcode: 46202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Clark Memorial Hospital",
    City: "Jeffersonville",
    State: "INDIANA",
    Zipcode: 4710,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Franciscan Health Lafayette East",
    City: "Lafayette",
    State: "INDIANA",
    Zipcode: 47905,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Select Specialty Hospital",
    City: "Evansville",
    State: "INDIANA",
    Zipcode: 47713,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Genesis Medical Center",
    City: "Davenport",
    State: "IOWA",
    Zipcode: 52803,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Chi Health Bergan Mercy",
    City: "Council Bluffs",
    State: "IOWA",
    Zipcode: 51503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Broadlawns Medical Center",
    City: "Des Moines",
    State: "IOWA",
    Zipcode: 50314,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "CHI Health Mercy Council Bluffs",
    City: "Council Bluffs",
    State: "IOWA",
    Zipcode: 51503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mercy Medical Center",
    City: "Cedar Rapids",
    State: "IOWA",
    Zipcode: 52403,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Iowa Health Care Medical C",
    City: "Iowa City",
    State: "IOWA",
    Zipcode: 52245,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "MercyOne Cedar Falls Medical Center",
    City: "Cedar Falls",
    State: "IOWA",
    Zipcode: 50613,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "MercyOne Des Moines Medical Center",
    City: "Des Moines",
    State: "IOWA",
    Zipcode: 50314,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mercy Medical Center Dubuque",
    City: "Dubuque",
    State: "IOWA",
    Zipcode: 52001,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mercyone Siouxland Medical Center",
    City: "Sioux City",
    State: "IOWA",
    Zipcode: 51101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mary Greeley Medical Center",
    City: "Ames",
    State: "IOWA",
    Zipcode: 50010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Trinity Bettendorf",
    City: "Bettendorf",
    State: "IOWA",
    Zipcode: 52722,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Lukes Methodist Hospital",
    City: "Cedar Rapids",
    State: "IOWA",
    Zipcode: 52402,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Blank Childrens Hospital",
    City: "Des Moines",
    State: "IOWA",
    Zipcode: 50309,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "IA Methodist Medical Center",
    City: "Des Moines",
    State: "IOWA",
    Zipcode: 50309,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Iowa Lutheran Hospital",
    City: "Des Moines",
    State: "IOWA",
    Zipcode: 50309,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Lukes Regional Medical Center",
    City: "Sioux City",
    State: "IOWA",
    Zipcode: 51104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Covenant Medical Center Inc",
    City: "Waterloo",
    State: "IOWA",
    Zipcode: 50702,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Allen Hospital",
    City: "Waterloo",
    State: "IOWA",
    Zipcode: 50703,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Waverly Health Center",
    City: "Waverly",
    State: "IOWA",
    Zipcode: 50677,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Belton Regional Medical Center",
    City: "Belton",
    State: "KANSAS",
    Zipcode: 64012,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Research Medical Center",
    City: "Kansas City",
    State: "KANSAS",
    Zipcode: 64130,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Menorah Medical Center",
    City: "Overland Park",
    State: "KANSAS",
    Zipcode: 66209,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kansas Heart Hospital",
    City: "Wichita",
    State: "KANSAS",
    Zipcode: 67226,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Rock Regional Hospital",
    City: "Derby",
    State: "KANSAS",
    Zipcode: 67037,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Shawnee Mission Medical Center",
    City: "Shawnee Mission",
    State: "KANSAS",
    Zipcode: 66204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "The Children's Mercy Hospital",
    City: "Overland Park",
    State: "KANSAS",
    Zipcode: 66211,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Kansas Hospital",
    City: "Kansas City",
    State: "KANSAS",
    Zipcode: 66101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Kansas City Orthopaedic Institute",
    City: "Overland Park",
    State: "KANSAS",
    Zipcode: 66204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kansas Spine and Specialty Hospital",
    City: "Wichita",
    State: "KANSAS",
    Zipcode: 67226,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Olathe Medical Center",
    City: "Olathe",
    State: "KANSAS",
    Zipcode: 66061,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Lukes Hospital of Kansas City",
    City: "Kansas City",
    State: "KANSAS",
    Zipcode: 64111,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Saint Luke's South Hospital",
    City: "Overland Park",
    State: "KANSAS",
    Zipcode: 66205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Satanta District Hospital",
    City: "Wichita",
    State: "KANSAS",
    Zipcode: 67211,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Susan B Allen Memorial Hospital",
    City: "Augusta",
    State: "KANSAS",
    Zipcode: 67010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Joseph Medical Center",
    City: "Kansas City",
    State: "KANSAS",
    Zipcode: 64114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Wesley Medical Center",
    City: "Wichita",
    State: "KANSAS",
    Zipcode: 67214,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ellsworth County Medical Center",
    City: "Wichita",
    State: "KANSAS",
    Zipcode: 67439,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Overland Park Regional Medical Center",
    City: "Overland Park",
    State: "KANSAS",
    Zipcode: 66215,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jewish Hospital",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Baptist Health Paducah",
    City: "Paducah",
    State: "KENTUCKY",
    Zipcode: 42003,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Norton Audubon Hospital",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40217,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Norton Hospital",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Norton Women’s and Children’s Hospital",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40207,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Norton Brownsboro Hospital",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40241,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Health Lexington",
    City: "Lexington",
    State: "KENTUCKY",
    Zipcode: 40503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Norton Children's Hospital ",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Norton Healthcare System",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Norton Children’s Medical Center",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40241,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "UK Albert B. Chandler Hospital Pavilion H",
    City: "Lexington",
    State: "KENTUCKY",
    Zipcode: 40536,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Regional Medical Center",
    City: "Corbin",
    State: "KENTUCKY",
    Zipcode: 40701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Health Urgent Care Louisville - Eastpoint",
    City: "Louisville",
    State: "KENTUCKY",
    Zipcode: 40223,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHI Saint Joseph Health - Saint Joseph Hospital",
    City: "Fayette",
    State: "KENTUCKY",
    Zipcode: 40504,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Elizabeth Covington Hospital",
    City: "Covington",
    State: "KENTUCKY",
    Zipcode: 41011,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Elizabeth Edgewood Hospital",
    City: "Edgewood",
    State: "KENTUCKY",
    Zipcode: 41017,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Elizabeth Florence Hospital",
    City: "Florence",
    State: "KENTUCKY",
    Zipcode: 41042,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Elizabeth Ft. Thomas Hospital",
    City: "Fort Thomas",
    State: "KENTUCKY",
    Zipcode: 41075,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Elizabeth Grant Hospital",
    City: "Williamstown",
    State: "KENTUCKY",
    Zipcode: 41097,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Childrens Hospital",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Baptist - A Campus of Ochsner Medical Center",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70115,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Tulane University Hospital and Clinic",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70112,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Medical Center - Baton Rouge",
    City: "Baton Rouge",
    State: "LOUISIANA",
    Zipcode: 70816,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "East Jefferson General Hospital",
    City: "Metairie",
    State: "LOUISIANA",
    Zipcode: 70006,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Our Lady of The Lake Reg Medical Center",
    City: "Baton Rouge",
    State: "LOUISIANA",
    Zipcode: 70805,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Baton Rouge General Medical Center",
    City: "Baton Rouge",
    State: "LOUISIANA",
    Zipcode: 70806,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Christus Schumpert Medical Center",
    City: "Shreveport",
    State: "LOUISIANA",
    Zipcode: 71105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "University Medical Center",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70112,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Touro Infirmary",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70115,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lake Charles Memorial Hospital",
    City: "Lake Charles",
    State: "LOUISIANA",
    Zipcode: 70601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Medical Center - Kenner",
    City: "Kenner",
    State: "LOUISIANA",
    Zipcode: 70119,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Medical Center - Northshore",
    City: "Lacombe",
    State: "LOUISIANA",
    Zipcode: 70121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Ochsner Medical Center",
    City: "Ochsner Medical Center",
    State: "LOUISIANA",
    Zipcode: 70121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Ochsner Health System",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Medical Center - West Bank Campus",
    City: "Gretna",
    State: "LOUISIANA",
    Zipcode: 70056,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Ochsner Hospital for Orthopedics & Sports Medicine",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Hospital for Children",
    City: "New Orleans",
    State: "LOUISIANA",
    Zipcode: 70121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ochsner Medical Center - Hancock",
    City: "Monroe",
    State: "LOUISIANA",
    Zipcode: 71202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Southern Maine Health Care",
    City: "Portland",
    State: "MAINE",
    Zipcode: 4102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Joseph Hospital- Evergreen Woods",
    City: "Bangor",
    State: "MAINE",
    Zipcode: 4401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Northern Light Maine Coast Hospital",
    City: "Brewer",
    State: "MAINE",
    Zipcode: 4605,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Northern Light Mayo Hospital",
    City: "Corinth",
    State: "MAINE",
    Zipcode: 4427,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Maine Medical Center",
    City: "Portland",
    State: "MAINE",
    Zipcode: 4101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St Joseph Hospital",
    City: "Brewer",
    State: "MAINE",
    Zipcode: 4401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Agnes Hospital",
    City: "Columbia",
    State: "MARYLAND ",
    Zipcode: 21046,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Grace Medical Center",
    City: "Baltimore",
    State: "MARYLAND ",
    Zipcode: 21223,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Franklin Square Hospital Center",
    City: "Dundalk",
    State: "MARYLAND ",
    Zipcode: 21222,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Maryland General Hospital",
    City: "Baltimore",
    State: "MARYLAND ",
    Zipcode: 21201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Baltimore Washington Medical Center",
    City: "Glen Burnie",
    State: "MARYLAND ",
    Zipcode: 21061,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "University of Marylad St. Joseph Medical Center ",
    City: "Towson",
    State: "MARYLAND ",
    Zipcode: 21204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Capital Womens care",
    City: "Laurel",
    State: "MARYLAND ",
    Zipcode: 20707,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "University of Maryland Medical Center",
    City: "Baltimore",
    State: "MARYLAND ",
    Zipcode: 21201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "BayRidge Hospital",
    City: "Beverly",
    State: "MASSACHUSETTS",
    Zipcode: 1904,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Floating Hospital for Children at Tufts Medical Center",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2111,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Beverly Hospital",
    City: "Beverly",
    State: "MASSACHUSETTS",
    Zipcode: 1915,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Addison Gilbert Hospital",
    City: "Gloucester",
    State: "MASSACHUSETTS",
    Zipcode: 1930,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Beth Israel Deaconess Medical Center",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2215,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Boston Medical Center",
    City: "East Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2128,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Brigham Womans Hospital",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2215,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mass General Hospital",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "MetroWest Medical Center",
    City: "Natick",
    State: "MASSACHUSETTS",
    Zipcode: 1760,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "New England Baptist Hospital",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2120,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Vincent Hospital",
    City: "Worcester",
    State: "MASSACHUSETTS",
    Zipcode: 1608,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Tufts Medical Center",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2116,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Marlborough Hospital",
    City: "Marlborough",
    State: "MASSACHUSETTS",
    Zipcode: 1752,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UMass Memorial Medical Center",
    City: "Worcester",
    State: "MASSACHUSETTS",
    Zipcode: 1605,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Signature Healthcare Brockton Hospital",
    City: "Hanson",
    State: "MASSACHUSETTS",
    Zipcode: 2302,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Cambridge Public Health Commission Hospital",
    City: "Everett",
    State: "MASSACHUSETTS",
    Zipcode: 2149,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Massachusetts Eye and Ear",
    City: "Stoneham",
    State: "MASSACHUSETTS",
    Zipcode: 2180,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Beaumont Hospital Grosse Pointe",
    City: "Grosse Pointe",
    State: "MICHIGAN",
    Zipcode: 48230,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Ascension Borgess-Lee Memorial Hospital",
    City: "Dowagiac",
    State: "MICHIGAN",
    Zipcode: 49047,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascension Providence Rochester Hospital",
    City: "Rochester Hills",
    State: "MICHIGAN",
    Zipcode: 48307,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Metro Health Hospital",
    City: "Wyoming",
    State: "MICHIGAN",
    Zipcode: 49519,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Harper Hutzel Hospital",
    City: "Detroit",
    State: "MICHIGAN",
    Zipcode: 48201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Henry Ford Macomb Hospital ",
    City: "Clinton Township",
    State: "MICHIGAN",
    Zipcode: 48038,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Karmanos Cancer Center",
    City: "Detroit",
    State: "MICHIGAN",
    Zipcode: 48201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mclaren Macomb",
    City: "Mount Clemens",
    State: "MICHIGAN",
    Zipcode: 48043,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Joseph Mercy Hospital",
    City: "Ypsilanti",
    State: "MICHIGAN",
    Zipcode: 48106,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "University of Michigan Health-Ann Arbor",
    City: "Ann Arbor",
    State: "MICHIGAN",
    Zipcode: 48105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "DMC Harper University Hospital",
    City: "Detroit",
    State: "MICHIGAN",
    Zipcode: 48201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Henry Ford Medical Center - Pierson",
    City: "Crosse Pointe Farms",
    State: "MICHIGAN",
    Zipcode: 48236,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Henry Ford Medical Center - Cottage",
    City: "Crosse Pointe Farms",
    State: "MICHIGAN",
    Zipcode: 48236,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Henry Ford Hospital",
    City: "Detroit",
    State: "MICHIGAN",
    Zipcode: 48207,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Henry Ford Wyandotte Hospital",
    City: "Wyandotte",
    State: "MICHIGAN",
    Zipcode: 48192,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Pontiac General Hospital",
    City: "Pontiac",
    State: "MICHIGAN",
    Zipcode: 48341,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Owatonna Hospital",
    City: "Saint Paul",
    State: "MINNESOTA ",
    Zipcode: 55102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Hennepin Healthcare System, Inc",
    City: "Minneapolis",
    State: "MINNESOTA ",
    Zipcode: 55415,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Park Nicollet Methodist Hospital",
    City: "Saint Louis Park",
    State: "MINNESOTA ",
    Zipcode: 55426,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "M Health Fairview Ridges Hospital",
    City: "Burnsville",
    State: "MINNESOTA ",
    Zipcode: 55337,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Maple Grove Hospital",
    City: "Maple Grove",
    State: "MINNESOTA ",
    Zipcode: 55369,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Allina Health United Hospital - Hastings",
    City: "Coon Rapids",
    State: "MINNESOTA ",
    Zipcode: 55433,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Buffalo Hospital",
    City: "Coon Rapids",
    State: "MINNESOTA ",
    Zipcode: 55433,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Abbott Northwestern Hospital",
    City: "Minneapolis",
    State: "MINNESOTA ",
    Zipcode: 55407,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Childrens Health Care",
    City: "Minneapolis",
    State: "MINNESOTA ",
    Zipcode: 55404,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Essentia Health St. Marys Medical Center",
    City: "Duluth",
    State: "MINNESOTA ",
    Zipcode: 55805,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Regions Hospital",
    City: "Saint Paul",
    State: "MINNESOTA ",
    Zipcode: 55101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Lukes Hospital Assn Duluth",
    City: "Duluth",
    State: "MINNESOTA ",
    Zipcode: 55805,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Forrest County General Hospital",
    City: "Hattiesburg",
    State: "MISSISSIPPI ",
    Zipcode: 39402,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Singing River Gulfport",
    City: "Gulfport",
    State: "MISSISSIPPI ",
    Zipcode: 39503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Hospital At Gulfport",
    City: "Gulfport",
    State: "MISSISSIPPI ",
    Zipcode: 39501,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Anderson Regional Medical Center",
    City: "Meridian",
    State: "MISSISSIPPI ",
    Zipcode: 39301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mississippi Baptist Medical Center Inc",
    City: "Jackson",
    State: "MISSISSIPPI ",
    Zipcode: 39202,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Dominic Memorial Hospital",
    City: "Jackson",
    State: "MISSISSIPPI ",
    Zipcode: 39216,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Merit Health Central",
    City: "Jackson",
    State: "MISSISSIPPI ",
    Zipcode: 39204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Mississippi Medical Center",
    City: "Tupelo",
    State: "MISSISSIPPI ",
    Zipcode: 38801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Ochsner Rush Medical Center",
    City: "Meridian",
    State: "MISSISSIPPI ",
    Zipcode: 39301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "River Oaks Hospital",
    City: "Flowood",
    State: "MISSISSIPPI ",
    Zipcode: 39232,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Singing River Hospital",
    City: "Pascagoula",
    State: "MISSISSIPPI ",
    Zipcode: 39581,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "University of Mississippi Medical Center",
    City: "Jackson",
    State: "MISSISSIPPI ",
    Zipcode: 39216,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Biloxi Regional Medical Center",
    City: "Biloxi",
    State: "MISSISSIPPI ",
    Zipcode: 39530,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Merit Health River Region",
    City: "Vicksburg",
    State: "MISSISSIPPI ",
    Zipcode: 39183,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "University of Mississipi Medical Center - Holmes County",
    City: "Lexington",
    State: "MISSISSIPPI ",
    Zipcode: 39095,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Children's Mercy Kansas City Hospital",
    City: "Kansas City",
    State: "MISSOURI",
    Zipcode: 64108,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Barnes-Jewish Hospital",
    City: "Saint Louis",
    State: "MISSOURI",
    Zipcode: 63110,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Christian Hospital",
    City: "St. Louis",
    State: "MISSOURI",
    Zipcode: 63136,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mercy Hospital St. Louis",
    City: "St. Louis",
    State: "MISSOURI",
    Zipcode: 63109,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Missouri Baptist Medical Center",
    City: "St. Louis",
    State: "MISSOURI",
    Zipcode: 63131,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ellis Fischel Cancer Center",
    City: "Columbia",
    State: "MISSOURI",
    Zipcode: 65212,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Missouri Orthopaedic Institute",
    City: "Columbia",
    State: "MISSOURI",
    Zipcode: 65212,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Missouri Psychiatric Center",
    City: "Columbia",
    State: "MISSOURI",
    Zipcode: 65201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "SSM Health St. Joseph Hospital- Lake Saint Louis",
    City: "Lake Saint Louis",
    State: "MISSOURI",
    Zipcode: 63367,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "SSM Health St. Joseph Hospital- St Charles",
    City: "Saint Charles",
    State: "MISSOURI",
    Zipcode: 63301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "SSM Health St. Marys Hospital- St. Louis",
    City: "Saint Louis",
    State: "MISSOURI",
    Zipcode: 63117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Luke’s Hospital",
    City: "Kansas City",
    State: "MISSOURI",
    Zipcode: 64111,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Louis Children's Hospital-Washington University",
    City: "Saint Louis",
    State: "MISSOURI",
    Zipcode: 63110,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University Hospital ",
    City: "Columbia",
    State: "MISSOURI",
    Zipcode: 65212,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Women's Hospital",
    City: "Columbia",
    State: "MISSOURI",
    Zipcode: 65201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Northwest HealthCare- Christian Hospital",
    City: "Florissant",
    State: "MISSOURI",
    Zipcode: 63031,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Capital Region Medical Center",
    City: "Columbia",
    State: "MISSOURI",
    Zipcode: 65101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Truman Medical Center Hospital Hill",
    City: "Kansas City",
    State: "MISSOURI",
    Zipcode: 64108,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Benefits East Campus",
    City: "Great Falls",
    State: "MONTANA",
    Zipcode: 59405,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Benefis NorthWest",
    City: "Great Falls",
    State: "MONTANA",
    Zipcode: 59404,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Benefis West Campus",
    City: "Great Falls",
    State: "MONTANA",
    Zipcode: 59405,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Billings Clinic Bozeman Surgery Center",
    City: "Billings",
    State: "MONTANA",
    Zipcode: 59101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Community Hospital of Anaconda",
    City: "Anaconda",
    State: "MONTANA",
    Zipcode: 59711,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Glendive Medical Center",
    City: "Glendive",
    State: "MONTANA",
    Zipcode: 59330,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Intermountain Health St. Vincent Regional",
    City: "Billings",
    State: "MONTANA",
    Zipcode: 59101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sidney Health Center",
    City: "Sidney",
    State: "MONTANA",
    Zipcode: 59270,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Benefis Central Campus",
    City: "Great Falls",
    State: "MONTANA",
    Zipcode: 59405,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Central Montana Medical Center",
    City: "Lewiston",
    State: "MONTANA",
    Zipcode: 59457,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Community Medical Center",
    City: "Missoula",
    State: "MONTANA",
    Zipcode: 59701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Cancer Center",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68115,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Chi Health St.Francis",
    City: "Grand Island",
    State: "NEBRASKA",
    Zipcode: 68803,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Columbus Community Hospital",
    City: "Columbus",
    State: "NEBRASKA",
    Zipcode: 68601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Nebraska Spine Hospital Llc",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68122,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Womens Hospital",
    City: "Elkhorn",
    State: "NEBRASKA",
    Zipcode: 68022,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Chi Health Immanuel",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68152,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Childrens Hospital and Medical Center",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Midwest Surgical Hospital",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68114,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Nebraska Medical Center",
    City: "Carson City",
    State: "NEBRASKA",
    Zipcode: 68105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Grand Island Regional Medical Center",
    City: "Grand Island",
    State: "NEBRASKA",
    Zipcode: 68801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name":
      "CHI Health Creighton University Medical Center Bergan Mercy",
    City: "Omaha",
    State: "NEBRASKA",
    Zipcode: 68124,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mary Laning Healthcare",
    City: "Grand Island",
    State: "NEBRASKA",
    Zipcode: 68803,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Mary’s Regional Medical Center",
    City: "Reno",
    State: "NEVADA",
    Zipcode: 89503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Carson Tahoe Regional Medical Center",
    City: "Carson City",
    State: "NEVADA",
    Zipcode: 89703,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Boulder City Hospital",
    City: "Boulder City",
    State: "NEVADA",
    Zipcode: 89005,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mountainview Hospital",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89128,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sunrise Hospital & Medical Center",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89109,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Desert Springs Hospital Medical Center",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89119,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Dignity St. Rose - Sahara",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89146,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Henderson Hospital",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89011,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Vista Hospital",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Spring Valley Hospital",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89118,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Summerlin Hospital Medical Center",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89144,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University Medical Center of Southern Nevada",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Valley Hospital Medical Center",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89106,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Incline Village Community Hospital",
    City: "Incline Village",
    State: "NEVADA",
    Zipcode: 89451,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Northern Nevada Sierra Medical Center",
    City: "Reno",
    State: "NEVADA",
    Zipcode: 89511,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Renown Regional Medical Center",
    City: "Reno",
    State: "NEVADA",
    Zipcode: 89502,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name":
      "Dignity Health - St. Rose Dominican Hospital, San Martin Campus",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89113,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name":
      "Dignity Health - St. Rose Dominican Hospital, Siena Campus",
    City: "Henderson",
    State: "NEVADA",
    Zipcode: 89052,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Concord Hospital - Franklin",
    City: "Franklin",
    State: "NEW HAMPSHIRE",
    Zipcode: 3235,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Joseph Hospital",
    City: "Nashua",
    State: "NEW HAMPSHIRE",
    Zipcode: 3054,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Portsmouth Regional Hospital",
    City: "Portsmouth",
    State: "NEW HAMPSHIRE",
    Zipcode: 3801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Cheshire Medical Center",
    City: "Keene",
    State: "NEW HAMPSHIRE",
    Zipcode: 3431,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mary Hitchcock Memorial Hospital",
    City: "Manchester",
    State: "NEW HAMPSHIRE",
    Zipcode: 3102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Frisbie Memorial Hospital",
    City: "Barrington",
    State: "NEW HAMPSHIRE",
    Zipcode: 3825,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "New London Hospital",
    City: "New London",
    State: "NEW HAMPSHIRE",
    Zipcode: 3257,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Wentworth-douglass Hospital",
    City: "Lee",
    State: "NEW HAMPSHIRE",
    Zipcode: 3861,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bayonne Hospital ",
    City: "Bayonne",
    State: "NEW JERSEY",
    Zipcode: 7002,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Saint Clare’s Dover Hospital",
    City: "Dover",
    State: "NEW JERSEY",
    Zipcode: 7801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Capital Health Regional Medical Center",
    City: "Trenton",
    State: "NEW JERSEY",
    Zipcode: 8638,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Morristown Memorial Hospital",
    City: "Whippany",
    State: "NEW JERSEY",
    Zipcode: 7981,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Chilton Medical Center",
    City: "Pompton Plains",
    State: "NEW JERSEY",
    Zipcode: 7444,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hackensack UMC Mountainside",
    City: "Montclair",
    State: "NEW JERSEY",
    Zipcode: 7042,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Capital Health Medical Center - Hopewell",
    City: "Pennington",
    State: "NEW JERSEY",
    Zipcode: 8534,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hackensack University Medical Center",
    City: "Hackensack",
    State: "NEW JERSEY",
    Zipcode: 7601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Ocean Medical Center",
    City: "Brick",
    State: "NEW JERSEY",
    Zipcode: 8724,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jersey Shore University Medical Center",
    City: "Neptune Townshi",
    State: "NEW JERSEY",
    Zipcode: 7753,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Palisades Medical Center",
    City: "North Bergen",
    State: "NEW JERSEY",
    Zipcode: 7047,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Riverview Medical Center",
    City: "Red Bank",
    State: "NEW JERSEY",
    Zipcode: 7701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Clara Maass Medical Center",
    City: "Belleville",
    State: "NEW JERSEY",
    Zipcode: 7109,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Trinitas Regional Medical Center",
    City: "Elizabeth",
    State: "NEW JERSEY",
    Zipcode: 7201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jersey City Medical Center",
    City: "Jersey City",
    State: "NEW JERSEY",
    Zipcode: 7302,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Monmouth Medical Center - Southern",
    City: "Lakewood",
    State: "NEW JERSEY",
    Zipcode: 8701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Virtua Our Lady of Lourdes Hospital",
    City: "Camden",
    State: "NEW JERSEY",
    Zipcode: 8103,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Virtua -West Jersey Health",
    City: "Marlton ",
    State: "NEW JERSEY",
    Zipcode: 8053,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Virtua Willingboro Hospital",
    City: "Willingboro",
    State: "NEW JERSEY",
    Zipcode: 8046,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "John F. Kennedy Medical Center",
    City: "Edison",
    State: "NEW JERSEY",
    Zipcode: 8820,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Atlantic Health System",
    City: "Morristown",
    State: "NEW JERSEY",
    Zipcode: 7960,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Morristown Medical Center",
    City: "Morristown",
    State: "NEW JERSEY",
    Zipcode: 7960,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Newark Beth Israel Medical Center",
    City: "Newark",
    State: "NEW JERSEY",
    Zipcode: 7112,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "AHS Overlook Medical Center",
    City: "Summit",
    State: "NEW JERSEY",
    Zipcode: 7901,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Saint Clare’s Denville Hospital",
    City: "Denville",
    State: "NEW JERSEY",
    Zipcode: 7834,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Virtua Marlton Hospital",
    City: "Marlton",
    State: "NEW JERSEY",
    Zipcode: 8053,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Virtua Memorial Hospital Burlington County ",
    City: "Mount Holly",
    State: "NEW JERSEY",
    Zipcode: 8060,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Eastern New Mexico Medical Center",
    City: "Roswell",
    State: "NEW MEXICO ",
    Zipcode: 88201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Gerald Champion Regional Medical Center",
    City: "Alamogordo",
    State: "NEW MEXICO ",
    Zipcode: 88310,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Gila Regional Medical Center",
    City: "Silver City",
    State: "NEW MEXICO ",
    Zipcode: 88061,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Nor-lea Hospital District",
    City: "Lovington",
    State: "NEW MEXICO ",
    Zipcode: 88260,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Carrie Tingley Hospital",
    City: "Albuquerque",
    State: "NEW MEXICO ",
    Zipcode: 87102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "University of New Mexico Hospital",
    City: "Albuquerque",
    State: "NEW MEXICO ",
    Zipcode: 87102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "los Alamos Medical Center",
    City: "Los Alamos",
    State: "NEW MEXICO ",
    Zipcode: 87544,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Roosevelt General Hospital",
    City: "Portales",
    State: "NEW MEXICO ",
    Zipcode: 88130,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Clovis Plains Regional Medical Center",
    City: "Clovis",
    State: "NEW MEXICO ",
    Zipcode: 88101,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Socorro General Hospital",
    City: "Socorro",
    State: "NEW MEXICO ",
    Zipcode: 87801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Covenant Health Hobbs Hospital",
    City: "Hobbs",
    State: "NEW MEXICO ",
    Zipcode: 88240,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Rehoboth Mckinley Christian Hospital",
    City: "Gallup",
    State: "NEW MEXICO ",
    Zipcode: 87301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sierra Vista Hospital",
    City: "Truth or Consequences",
    State: "NEW MEXICO ",
    Zipcode: 87901,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Mimbres Memorial Hospital",
    City: "Deming",
    State: "NEW MEXICO ",
    Zipcode: 88030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Miners Colfax Medical Center",
    City: "Raton",
    State: "NEW MEXICO ",
    Zipcode: 87740,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Unm Sandoval Regional Medical Center",
    City: "Albuquerque",
    State: "NEW MEXICO ",
    Zipcode: 87144,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Lincoln County Medical Center",
    City: "Ruidoso",
    State: "NEW MEXICO ",
    Zipcode: 88345,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Carlsbad Medical Center",
    City: "Carlsbad",
    State: "NEW MEXICO ",
    Zipcode: 88220,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Brooklyn Hospital Center",
    City: "Brooklyn",
    State: "NEW YORK",
    Zipcode: 11201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Hudson Valley Hospital Center",
    City: "Cold Spring",
    State: "NEW YORK",
    Zipcode: 10516,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Columbia Memorial Health",
    City: "Hudson",
    State: "NEW YORK",
    Zipcode: 12534,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "St. Barnabas Hospital",
    City: "Bronx",
    State: "NEW YORK",
    Zipcode: 10457,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Stony Brook Southhampton ",
    City: "Southhampton",
    State: "NEW YORK",
    Zipcode: 11968,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Staten Island University Hospital",
    City: "Staten Island",
    State: "NEW YORK",
    Zipcode: 10305,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Good Samaritan Hospital Medical Center",
    City: "West Islip",
    State: "NEW YORK",
    Zipcode: 11795,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Long Island Community Hospital",
    City: "Suffolk",
    State: "NEW YORK",
    Zipcode: 11772,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Montefiore Nyack Hospital",
    City: "Nyack",
    State: "NEW YORK",
    Zipcode: 10960,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "NYU Langone Hospital Long Island",
    City: "Mineola",
    State: "NEW YORK",
    Zipcode: 10023,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "St. Francis Hospital, The Heart Center",
    City: "Roslyn",
    State: "NEW YORK",
    Zipcode: 11576,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hospital for Special Surgery",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10021,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Montefiore Medical Center ",
    City: "bronx",
    State: "NEW YORK",
    Zipcode: 11226,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Sinai Brooklyn",
    City: "Brooklyn",
    State: "NEW YORK",
    Zipcode: 11234,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Sinai Hospital",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10003,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Niagara Falls Memorial Medical Center",
    City: "Niagara Falls",
    State: "NEW YORK",
    Zipcode: 14301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Phelps Memorial Hospital Center",
    City: "Croton-On-Hudson",
    State: "NEW YORK",
    Zipcode: 10520,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "North Shore University Hospital",
    City: "Manhasset",
    State: "NEW YORK",
    Zipcode: 11030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Long Island Jewish Medical Center",
    City: "New Hyde Park",
    State: "NEW YORK",
    Zipcode: 11374,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lenox Hill Hospital",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10065,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Cohen Children’s Medical Center",
    City: "Queens",
    State: "NEW YORK",
    Zipcode: 11040,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Putnam Hospital Center",
    City: "Carmel ",
    State: "NEW YORK",
    Zipcode: 10512,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Bellevue Hospital",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "New York Presbyterian",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10032,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Westchester Medical Center ",
    City: "Valhalla ",
    State: "NEW YORK",
    Zipcode: 10595,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Wyckoff Heights Medical Center ",
    City: "Brooklyn ",
    State: "NEW YORK",
    Zipcode: 11237,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "LIJ Medical Center ",
    City: "New Hyde Park",
    State: "NEW YORK",
    Zipcode: 11040,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "MSK Sloan Kettering",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10065,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mount Sinai Morningside",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10025,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Sinai Queens",
    City: "Long Island City",
    State: "NEW YORK",
    Zipcode: 11102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Sinai West",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10019,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "MSK Kids at Memorial Sloan Kettering Cancer Center",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10065,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "David H Koch Center ",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10065,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "NYU Langone Health - Perlmutter Cancer Center",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Rusk Rehabilitation at NYU Langone Health",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10003,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "NYU Langone Health",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Sinai Beth Israel - Petrie Division",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10003,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Charles Hospital ",
    City: "Port Jefferson",
    State: "NEW YORK",
    Zipcode: 11777,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Stony Brook University Hospital ",
    City: "Stony Brook",
    State: "NEW YORK",
    Zipcode: 11794,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "NYU Langone Tisch Hospital",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10016,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Atrium Health University City",
    City: "Charlotte",
    State: "NORTH CAROLINA ",
    Zipcode: 28262,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Atrium Health Wake Forest Baptist Hospital",
    City: "Wiston Salem",
    State: "NORTH CAROLINA ",
    Zipcode: 27157,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Duke Children's Hospital and Health Center",
    City: "Durham",
    State: "NORTH CAROLINA ",
    Zipcode: 27710,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Duke University Medical Center",
    City: "Durham",
    State: "NORTH CAROLINA ",
    Zipcode: 27711,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Levine Children's Hospital",
    City: "Charlotte",
    State: "NORTH CAROLINA ",
    Zipcode: 28203,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Atrium Health Pineville",
    City: "Charlotte",
    State: "NORTH CAROLINA ",
    Zipcode: 28210,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Carolinas Medical Center",
    City: "Charlotte",
    State: "NORTH CAROLINA ",
    Zipcode: 28208,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Frye Regional Medical Center",
    City: "Hickory",
    State: "NORTH CAROLINA ",
    Zipcode: 28601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Novant Health Hemby Childrens Hospital",
    City: "Charlotte",
    State: "NORTH CAROLINA ",
    Zipcode: 28204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Novant Health Presbyterian Medical Center",
    City: "Charlotte",
    State: "NORTH CAROLINA ",
    Zipcode: 28205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Rex Hospital",
    City: "Raleigh",
    State: "NORTH CAROLINA ",
    Zipcode: 27607,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "High Point Regional Hospital",
    City: "High Point",
    State: "NORTH CAROLINA ",
    Zipcode: 27262,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Wakemed Raleigh Campus",
    City: "Raleigh",
    State: "NORTH CAROLINA ",
    Zipcode: 27610,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of North Carolina Hospitals",
    City: "Raleigh",
    State: "NORTH CAROLINA ",
    Zipcode: 27607,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "UNC Rex Hospital",
    City: "Raleigh",
    State: "NORTH CAROLINA ",
    Zipcode: 27607,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Essentia Health",
    City: "Fargo",
    State: "NORTH DAKOTA ",
    Zipcode: 58103,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Chi St. Alexius Health Bismarck",
    City: "Bismarck",
    State: "NORTH DAKOTA ",
    Zipcode: 58501,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jamestown Regional Medical Center",
    City: "Jamestown",
    State: "NORTH DAKOTA ",
    Zipcode: 58401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mckenzie County Healthcare Systems",
    City: "Watford City",
    State: "NORTH DAKOTA ",
    Zipcode: 58854,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "SMP Health St. Andrews",
    City: "Bottineau",
    State: "NORTH DAKOTA ",
    Zipcode: 58318,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Altru Hospital",
    City: "Grand Forks",
    State: "NORTH DAKOTA ",
    Zipcode: 58201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Pembina County Memorial Hospital",
    City: "Cavalier",
    State: "NORTH DAKOTA ",
    Zipcode: 58220,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Chi St. Alexius Health Carrington",
    City: "Carrington",
    State: "NORTH DAKOTA ",
    Zipcode: 58421,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "First Care Health Center",
    City: "Park River",
    State: "NORTH DAKOTA ",
    Zipcode: 58270,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Heart of America Medical Center",
    City: "Rugby",
    State: "NORTH DAKOTA ",
    Zipcode: 58368,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mercy Hospital of Valley City",
    City: "Valley City",
    State: "NORTH DAKOTA ",
    Zipcode: 58072,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Trinity Hospitals",
    City: "Minot",
    State: "NORTH DAKOTA ",
    Zipcode: 58701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "The Cleveland Spine Institute",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44130,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "The Neurological Institute at Cleveland Clinic",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44124,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Stephanie Tubbs Jones Health Center",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44112,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Rainbow Babies & Children’s Hospital",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44106,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "UH Seidman Cancer Center",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44106,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Cincinnati Children's Hospital Med Center ",
    City: "Cincinnati",
    State: "OHIO",
    Zipcode: 45014,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Cleveland Clinic",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44195,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Miller Family Heart and Vascular Institute",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44195,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "MetroHealth Medical Center",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44113,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Promedica Toledo Hospital",
    City: "Sylvania",
    State: "OHIO",
    Zipcode: 43560,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Christ Hospital",
    City: "Cincinnati",
    State: "OHIO",
    Zipcode: 45219,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of Cincinnati Medical Center",
    City: "Cincinnati",
    State: "OHIO",
    Zipcode: 45219,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Carmel East ",
    City: "Columbus",
    State: "OHIO",
    Zipcode: 43213,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Nationwide Children's Hospital",
    City: "Columbus",
    State: "OHIO",
    Zipcode: 43205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Grant Medical Center",
    City: "Columbus",
    State: "OHIO",
    Zipcode: 43215,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Riverside Methodist Hospital",
    City: "Columbus",
    State: "OHIO",
    Zipcode: 43214,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Promedica Defiance Regional Hospital",
    City: "Defiance",
    State: "OHIO",
    Zipcode: 43512,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Promedica Memorial Hospital",
    City: "Fremont",
    State: "OHIO",
    Zipcode: 43420,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Division of Promedica Toledo Hospital",
    City: "Toledo",
    State: "OHIO",
    Zipcode: 43606,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Cleveland Clinic - South Pointe Hospital",
    City: "Warrensville Heights",
    State: "OHIO",
    Zipcode: 44122,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Center for Spine Health Cleveland Clinic",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44195,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University Hospital Cleveland Medical Center",
    City: "Cleveland",
    State: "OHIO",
    Zipcode: 44106,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Ascension St. John Medical Center",
    City: "tulsa",
    State: "OKLAHOMA ",
    Zipcode: 74104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. John Medical Center ",
    City: "Tulsa",
    State: "OKLAHOMA ",
    Zipcode: 74104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hillcrest Medical Center",
    City: "Tulsa",
    State: "OKLAHOMA ",
    Zipcode: 74104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Hillcrest Hospital South",
    City: "Tulsa",
    State: "OKLAHOMA ",
    Zipcode: 74133,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Integris Baptist Medical Center",
    City: "Oklahoma City",
    State: "OKLAHOMA ",
    Zipcode: 73112,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Ou Medical Center",
    City: "Oklahoma City",
    State: "OKLAHOMA ",
    Zipcode: 73104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Norman Regional Hospital",
    City: "Norman",
    State: "OKLAHOMA ",
    Zipcode: 73071,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "SSM Health St. Anthony Hospital",
    City: "Midwest City",
    State: "OKLAHOMA ",
    Zipcode: 73110,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Adventist Health Portland",
    City: "Portland",
    State: "OREGON ",
    Zipcode: 97216,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Providence Medford Hospital & Medical Center",
    City: "Medford",
    State: "OREGON ",
    Zipcode: 97504,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Providence Willamette Falls Med Center ",
    City: "Oregon City",
    State: "OREGON ",
    Zipcode: 97045,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Providence Milwaukie Hospital",
    City: "Portland",
    State: "OREGON ",
    Zipcode: 97222,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Asante Ashland Community Hospital",
    City: "Ashland",
    State: "OREGON ",
    Zipcode: 97520,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Asante Three Rivers Medical Center",
    City: "Grants Pass",
    State: "OREGON ",
    Zipcode: 97527,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Legacy Mount Hood Medical Center",
    City: "Gresham",
    State: "OREGON ",
    Zipcode: 97030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Legacy Emanuel Hospital",
    City: "Portland",
    State: "OREGON ",
    Zipcode: 97227,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "McKenzie Willamette Medical Center",
    City: "Springfield",
    State: "OREGON ",
    Zipcode: 97477,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Willamette Valley Medical Center Llc",
    City: "Mcminnville",
    State: "OREGON ",
    Zipcode: 97128,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Legacy Good Samaritan Hospital",
    City: "Portland",
    State: "OREGON ",
    Zipcode: 97210,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Salem Hospital",
    City: "Salem",
    State: "OREGON ",
    Zipcode: 97301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Charles Health System Inc",
    City: "Bend",
    State: "OREGON ",
    Zipcode: 97701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Taylor Hospital",
    City: "Ridley Park",
    State: "PENNSYLVANIA",
    Zipcode: 19078,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Temple University Hospital",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19140,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Main Line Health Bryn Mawr Hospital",
    City: "Bryn Mawr",
    State: "PENNSYLVANIA",
    Zipcode: 19010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hospitals of the University of Pennsylvania",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Crozer - Chester Medical Center",
    City: "Chester",
    State: "PENNSYLVANIA",
    Zipcode: 19013,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Thomas Jefferson University Hospital",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19107,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Albert Einstein Medical Center",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19141,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Pennsylvania Hospital",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19107,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Magee Womens Hospital of UPMC",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15213,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Abington Hospital Jefferson Health",
    City: "Abington",
    State: "PENNSYLVANIA",
    Zipcode: 19001,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital at Jefferson University",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19148,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lankenau Medical Center",
    City: "Wynnewood",
    State: "PENNSYLVANIA",
    Zipcode: 19096,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Main Line Health Paoli Hospital",
    City: "King of Prussia",
    State: "PENNSYLVANIA",
    Zipcode: 19301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Passavant Hospital",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15237,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Penn Medicine Southern Chester County",
    City: "West Grove",
    State: "PENNSYLVANIA",
    Zipcode: 19390,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "UPMC Somerset",
    City: "Somerset",
    State: "PENNSYLVANIA",
    Zipcode: 15501,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Altoona",
    City: "Altoona",
    State: "PENNSYLVANIA",
    Zipcode: 16601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Bedford Memorial",
    City: "Everett",
    State: "PENNSYLVANIA",
    Zipcode: 15537,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Children’s Hospital of Pittsburgh",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15224,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC East",
    City: "Monroeville",
    State: "PENNSYLVANIA",
    Zipcode: 15146,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Horizon",
    City: "Farrell",
    State: "PENNSYLVANIA",
    Zipcode: 16121,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Mckeesport",
    City: "Mckeesport",
    State: "PENNSYLVANIA",
    Zipcode: 15132,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Mercy",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15219,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Northwest",
    City: "Seneca",
    State: "PENNSYLVANIA",
    Zipcode: 16346,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC Presbyterian Shadyside",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15232,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UPMC St. Margaret Hospital",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15215,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Children’s Hospital of Philadelphia",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19140,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Our Lady of Fatima Hospital",
    City: "Providence",
    State: "RHODE ISLAND ",
    Zipcode: 2907,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Roger Williams Medical Center",
    City: "Providence",
    State: "RHODE ISLAND ",
    Zipcode: 2908,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Hasbro Childrens Hospital",
    City: "Providence",
    State: "RHODE ISLAND ",
    Zipcode: 2903,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Kent County Memorial Hospital",
    City: "Warwick",
    State: "RHODE ISLAND ",
    Zipcode: 2906,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Landmark Medical Center",
    City: "Woonsocket",
    State: "RHODE ISLAND ",
    Zipcode: 2895,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Miriam Hospital",
    City: "Providence",
    State: "RHODE ISLAND ",
    Zipcode: 2906,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "South County Hospital",
    City: "Narragansett",
    State: "RHODE ISLAND ",
    Zipcode: 2882,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Women and Infants Hospital",
    City: "Providence",
    State: "RHODE ISLAND ",
    Zipcode: 2903,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Butler Hospital",
    City: "Providence",
    State: "RHODE ISLAND ",
    Zipcode: 2906,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Rhode Island Hospital",
    City: "East Greenwich",
    State: "RHODE ISLAND ",
    Zipcode: 2903,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Westerly Hospital ",
    City: "Westerly",
    State: "RHODE ISLAND ",
    Zipcode: 2891,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Conway Hospital",
    City: "Myrtle Beach",
    State: "SOUTH CAROLINA ",
    Zipcode: 29579,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "East Cooper Medical Center",
    City: "Mount Pleasant",
    State: "SOUTH CAROLINA ",
    Zipcode: 29464,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Grand Strand Regional Medical Center",
    City: "Myrtle Beach",
    State: "SOUTH CAROLINA ",
    Zipcode: 29572,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bon Secours St. Francis Downtown",
    City: "Greenville",
    State: "SOUTH CAROLINA ",
    Zipcode: 29601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bon Secours St. Francis Surgery Center",
    City: "Greenville",
    State: "SOUTH CAROLINA ",
    Zipcode: 29601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Francis Downtown",
    City: "Greenville",
    State: "SOUTH CAROLINA ",
    Zipcode: 29601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Musc Health Chester Medical Center",
    City: "Charleston",
    State: "SOUTH CAROLINA ",
    Zipcode: 29574,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lexington Medical Center",
    City: "Lexington",
    State: "SOUTH CAROLINA ",
    Zipcode: 29072,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Piedmont Medical Center",
    City: "Rock Hill",
    State: "SOUTH CAROLINA ",
    Zipcode: 29732,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bon Secours St. Francis Eastside",
    City: "Greenville",
    State: "SOUTH CAROLINA ",
    Zipcode: 29615,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Trident Medical Center",
    City: "Charleston",
    State: "SOUTH CAROLINA ",
    Zipcode: 29406,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Avera St. Lukes Hospital",
    City: "Aberdeen",
    State: "SOUTH DAKOTA ",
    Zipcode: 57401,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Avera St. Marys Hospital",
    City: "Pierre",
    State: "SOUTH DAKOTA ",
    Zipcode: 57108,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Fall River Hospital",
    City: "Hot Springs",
    State: "SOUTH DAKOTA ",
    Zipcode: 57747,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Mobridge Regional Hospital",
    City: "Mobridge",
    State: "SOUTH DAKOTA ",
    Zipcode: 57601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Brookings Hospital",
    City: "Brookings",
    State: "SOUTH DAKOTA ",
    Zipcode: 57006,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Avera Mckennan Hospital & University Health Hospital",
    City: "Sioux Falls",
    State: "SOUTH DAKOTA ",
    Zipcode: 57105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Select Specialty Hospital South Dakota",
    City: "Sioux Falls",
    State: "SOUTH DAKOTA ",
    Zipcode: 57105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Sioux Falls Specialty Hospital",
    City: "Sioux Falls",
    State: "SOUTH DAKOTA ",
    Zipcode: 57105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Sanford Vermillion Hospital",
    City: "Vermillion",
    State: "SOUTH DAKOTA ",
    Zipcode: 57069,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "CHI Memorial Hospital",
    City: "Chattanooga",
    State: "TENNESSEE",
    Zipcode: 37404,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "CHI Memorial Hospital Hixson",
    City: "Hixson",
    State: "TENNESSEE",
    Zipcode: 37343,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "TriStar Summit Medical Center",
    City: "Hermitage",
    State: "TENNESSEE",
    Zipcode: 37076,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "TriStar Centennial Medical Center",
    City: "Nashville",
    State: "TENNESSEE",
    Zipcode: 37203,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "TriStar Southern Hills Medical Center",
    City: "Nashville",
    State: "TENNESSEE",
    Zipcode: 37211,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Saint Thomas Hospital",
    City: "Nashville",
    State: "TENNESSEE",
    Zipcode: 37236,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist University Hospital",
    City: "Memphis",
    State: "TENNESSEE",
    Zipcode: 38104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Regional One Health",
    City: "Memphis",
    State: "TENNESSEE",
    Zipcode: 38103,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "TriStar StoneCrest Medical Center",
    City: "Smyrna",
    State: "TENNESSEE",
    Zipcode: 37167,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Vanderbilt Childrens Hospital",
    City: "Nashville",
    State: "TENNESSEE",
    Zipcode: 37232,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Nashville General Hospital",
    City: "Nashville",
    State: "TENNESSEE",
    Zipcode: 37208,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Parkridge East Hospital",
    City: "Chattanooga",
    State: "TENNESSEE",
    Zipcode: 37412,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Parkridge Medical Center",
    City: "Chattanooga",
    State: "TENNESSEE",
    Zipcode: 37404,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Jude Children's Research Hospital",
    City: "Memphis",
    State: "TENNESSEE",
    Zipcode: 38105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Vanderbilt University Medical Center",
    City: "Nashville",
    State: "TENNESSEE",
    Zipcode: 37232,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Houston Medical Center ",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77004,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Ascension Seton Medical Center ",
    City: "Austin",
    State: "TEXAS",
    Zipcode: 78705,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Baylor Scott & White- Irving",
    City: "Irving",
    State: "TEXAS",
    Zipcode: 75061,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baylor Scott & White- Mckinney",
    City: "Mckinney",
    State: "TEXAS",
    Zipcode: 75071,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baylor Scott & White - Uptown",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baylor University Medical Center ",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75246,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Christus St. Elizabeth ",
    City: "Beaumont",
    State: "TEXAS",
    Zipcode: 77702,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Cullen Eye Institute at Houston Methodist Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Medical Center Dialysis ",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77004,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Del Sol Medical Center",
    City: "El Paso",
    State: "TEXAS",
    Zipcode: 79925,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Dell Seton Medical Center ",
    City: "Austin",
    State: "TEXAS",
    Zipcode: 78701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Doctors Hospital At Edingurg ",
    City: "Edinburg",
    State: "TEXAS",
    Zipcode: 78539,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Lukes The Woodlands ",
    City: "The Woodlands",
    State: "TEXAS",
    Zipcode: 77384,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Ambulatory Surgery Hospital",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78240,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Medical City Arlington",
    City: "Arlington",
    State: "TEXAS",
    Zipcode: 76015,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Medical City Dallas ",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75230,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Medical City Las Colinas ",
    City: "Irving",
    State: "TEXAS",
    Zipcode: 75039,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Medical City Plano Hospital ",
    City: "Plano",
    State: "TEXAS",
    Zipcode: 75075,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "East El Paso Physicians' Medical Center",
    City: "El Paso",
    State: "TEXAS",
    Zipcode: 79936,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. David’s North Austin Medical Center",
    City: "Austin",
    State: "TEXAS",
    Zipcode: 78758,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Harlingen VAMC",
    City: "Harlingen",
    State: "TEXAS",
    Zipcode: 78550,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Baptist Medical Center",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78205,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Emergency Hospital",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78224,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Baylor St. Luke's Medical Center",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Luke's Episcopal Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Dallas Medical Center",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75234,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Children's Medical Center Dallas",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75235,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHRISTUS Children's",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78207,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Christus Santa Rosa Hospital Medical Center",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Christus Santa Rosa Hospital - Alamo Heights",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78209,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Christus New Braunfels",
    City: "New Braunfels",
    State: "TEXAS",
    Zipcode: 78130,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Christus Santa Rosa Hospital - San Marco",
    City: "San Marcos",
    State: "TEXAS",
    Zipcode: 78666,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Christus Santa Rosa Westover Hills",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78251,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Christus Spohn Hospital Beeville",
    City: "Beeville",
    State: "TEXAS",
    Zipcode: 78102,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Las Palmas Medical Center",
    City: "El Paso",
    State: "TEXAS",
    Zipcode: 79902,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "MD Anderson",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Harlingen Medical Center",
    City: "Harlingen",
    State: "TEXAS",
    Zipcode: 78550,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "DHR Health",
    City: "Edinburg",
    State: "TEXAS",
    Zipcode: 78539,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Valley Regional Medical Center",
    City: "Brownsville",
    State: "TEXAS",
    Zipcode: 78526,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Houston Healthcare North Cypress",
    City: "houston",
    State: "TEXAS",
    Zipcode: 77429,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "HCA Houston Healthcare Northwest",
    City: "houston",
    State: "TEXAS",
    Zipcode: 77090,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Northeast Baptist Hospital",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78217,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University Health System",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Hospitals of Providence Memorial Campus",
    City: "El Paso",
    State: "TEXAS",
    Zipcode: 79902,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Hospitals of Providence Sierra Campus",
    City: "El Paso",
    State: "TEXAS",
    Zipcode: 79902,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sacred Heart Emergency Center",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77055,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Sacred Heart Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77056,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Houston Methodist Baytown Hospital",
    City: "Baytown",
    State: "TEXAS",
    Zipcode: 77521,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Houston Methodist Clear Lake Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77058,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Houston Methodist West Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77094,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Texas Orthopedic Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Woman's Hospital of Texas",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77054,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "CHI St. Luke’s Health - Lakeside Hospital",
    City: "Montgomery",
    State: "TEXAS",
    Zipcode: 77384,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Hermann Katy Hospital",
    City: "Katy",
    State: "TEXAS",
    Zipcode: 77494,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Hermann Northeast Hospital",
    City: "Humble",
    State: "TEXAS",
    Zipcode: 77338,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Hermann The Woodlands Medical Center",
    City: "Woodlands",
    State: "TEXAS",
    Zipcode: 77380,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Dallas Medical Center",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75203,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Southwest Texas Methodist Hospital",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital Metropolitan",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78212,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Northeast Methodist Hospital",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78233,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital Specialty and Transplant",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital Stone Oak",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78258,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Methodist Hospital Texsan",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Nacogdoches Medical Center",
    City: "Nacogdoches",
    State: "TEXAS",
    Zipcode: 75965,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Scottish Rite for Children Hospital",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75219,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. David’s Medical Center",
    City: "Austin",
    State: "TEXAS",
    Zipcode: 78705,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Austin Medical",
    City: "Austin",
    State: "TEXAS",
    Zipcode: 78758,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Luke’s Baptist Hospital",
    City: "San Antonio",
    State: "TEXAS",
    Zipcode: 78229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHI St. Luke’s Health - Patients Medical Center",
    City: "Harris",
    State: "TEXAS",
    Zipcode: 77505,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHI St. Luke’s Health - Sugar Land Hospital",
    City: "Sugar Land",
    State: "TEXAS",
    Zipcode: 77478,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Breckenridge Medical Clinic",
    City: "Breckenridge",
    State: "TEXAS",
    Zipcode: 76424,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Houston Methodist Sugar Land Hospital",
    City: "Sugar Land",
    State: "TEXAS",
    Zipcode: 77479,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Texas Children’s Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Houston Methodist Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Hermann Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University Medical Center of El Paso",
    City: "El Paso",
    State: "TEXAS",
    Zipcode: 79905,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "UT Southwestern Medical Center",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75390,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Valley Baptist Medical Center",
    City: "Harlingen",
    State: "TEXAS",
    Zipcode: 78550,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Doctors Hospitals of Laredo",
    City: "Laredo",
    State: "TEXAS",
    Zipcode: 78045,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Rio Grande Regional Hospital",
    City: "McAllen",
    State: "TEXAS",
    Zipcode: 78503,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Woman’s Hospital of Texas",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77054,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Houston Methodist Willowbrook Hospital",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77070,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Alta View Hospital",
    City: "Sandy",
    State: "UTAH ",
    Zipcode: 84094,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Brigham City Community Hospital",
    City: "Brigham City",
    State: "UTAH ",
    Zipcode: 84302,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Holy Cross Hospital Davis",
    City: "Layton",
    State: "UTAH ",
    Zipcode: 84041,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Lakeview Hospital",
    City: "Bountiful",
    State: "UTAH ",
    Zipcode: 84010,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Lone Peak Hospital",
    City: "Draper",
    State: "UTAH ",
    Zipcode: 84020,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ogden Regional Medical Center",
    City: "Ogden",
    State: "UTAH ",
    Zipcode: 84405,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Mark’s Hospital",
    City: "Salt Lake City",
    State: "UTAH ",
    Zipcode: 84124,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Orthopedic Spec Hospital",
    City: "Murray",
    State: "UTAH ",
    Zipcode: 84107,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Brattleboro Memorial Hospital",
    City: "Brattleboro",
    State: "VERMONT ",
    Zipcode: 5301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Central Vermont Medical Center Inc",
    City: "Barre",
    State: "VERMONT ",
    Zipcode: 5641,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Mount Ascutney Hospital & Health Center",
    City: "Windsor",
    State: "VERMONT ",
    Zipcode: 5089,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Grace Cottage Hospital",
    City: "Townshend",
    State: "VERMONT ",
    Zipcode: 5353,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bon Secours Health Center at Harbour View",
    City: "Suffolk",
    State: "VIRGINIA ",
    Zipcode: 23435,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Maryview Medical Center",
    City: "Norfolk",
    State: "VIRGINIA ",
    Zipcode: 23505,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Chippenham Hospital",
    City: "Richmond",
    State: "VIRGINIA ",
    Zipcode: 23225,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Clinch Valley Medical Center",
    City: "Richlands",
    State: "VIRGINIA ",
    Zipcode: 24641,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Henrico Doctors Hospital",
    City: "Richmond",
    State: "VIRGINIA ",
    Zipcode: 23229,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Chesapeake Regional Medical Center",
    City: "Virginia Beach",
    State: "VIRGINIA ",
    Zipcode: 23320,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Page Memorial Hospital",
    City: "Shenandoah",
    State: "VIRGINIA ",
    Zipcode: 22849,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Virginia Hospital Center",
    City: "Alexandria",
    State: "VIRGINIA ",
    Zipcode: 22314,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Inova Alexandria Hospital",
    City: "Alexandria",
    State: "VIRGINIA ",
    Zipcode: 22304,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Inova Fair Oaks Hospital",
    City: "Fairfax",
    State: "VIRGINIA ",
    Zipcode: 22033,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Inova Fairfax Hospital",
    City: "Falls Church",
    State: "VIRGINIA ",
    Zipcode: 22042,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Inova Mount Vernon Hospital",
    City: "Alexandria",
    State: "VIRGINIA ",
    Zipcode: 22306,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Reston Hospital Center",
    City: "Reston",
    State: "VIRGINIA ",
    Zipcode: 20190,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sentara Northern Virginia Medical Center",
    City: "Woodbridge",
    State: "VIRGINIA ",
    Zipcode: 22191,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Multicare Valley Hospital",
    City: "Spokane Valley",
    State: "WASHINGTON",
    Zipcode: 99216,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Multicare Deaconess Hospital",
    City: "Spokane",
    State: "WASHINGTON",
    Zipcode: 99204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bellevue Medical Center",
    City: "Bellevue",
    State: "WASHINGTON",
    Zipcode: 98004,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Anne Hospital",
    City: "Burien",
    State: "WASHINGTON",
    Zipcode: 98166,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Overlake Hospital Medical Center",
    City: "Bellevue",
    State: "WASHINGTON",
    Zipcode: 98004,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Swedish Cherry Hill Campus",
    City: "Seattle",
    State: "WASHINGTON",
    Zipcode: 98122,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "University of Washington Medical Center",
    City: "Seattle",
    State: "WASHINGTON",
    Zipcode: 98195,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Valley Medical Center",
    City: "Renton",
    State: "WASHINGTON",
    Zipcode: 98055,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Michael Medical Center",
    City: "Bremerton",
    State: "WASHINGTON",
    Zipcode: 98310,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Clare Hospital",
    City: "Lakewood",
    State: "WASHINGTON",
    Zipcode: 98499,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Virginia Mason Medical Center",
    City: "Seattle",
    State: "WASHINGTON",
    Zipcode: 98104,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Mary Bridge Children's Hospital",
    City: "Tacoma",
    State: "WASHINGTON",
    Zipcode: 98403,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Peacehealth Southwest Medical Center",
    City: "Vancouver",
    State: "WASHINGTON",
    Zipcode: 98664,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Providence Holy Family Hospital",
    City: "Spokane",
    State: "WASHINGTON",
    Zipcode: 99208,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Providence Regional Medical Center",
    City: "Everett",
    State: "WASHINGTON",
    Zipcode: 98201,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Sacred Heart Children's Hospital",
    City: "Spokane",
    State: "WASHINGTON",
    Zipcode: 99204,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Seattle Children's Hospital",
    City: "Seattle",
    State: "WASHINGTON",
    Zipcode: 98105,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "St. Anthony Hospital",
    City: "Gig Harbor",
    State: "WASHINGTON",
    Zipcode: 98332,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Francis Hospital",
    City: "Federal Way",
    State: "WASHINGTON",
    Zipcode: 98003,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "CHI Franciscan Rehabilitation Hospital",
    City: "Pierce",
    State: "WASHINGTON",
    Zipcode: 98465,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Howard University Hospital",
    City: "Washington",
    State: "WASHINGTON, DC ",
    Zipcode: 20060,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "MedStar Georgetown University Hospital",
    City: "Washington",
    State: "WASHINGTON, DC ",
    Zipcode: 20007,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Broaddus Hospital",
    City: "Philippi",
    State: "WEST VIRGINIA ",
    Zipcode: 26416,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "St. Mary's Medical Center",
    City: "Huntington",
    State: "WEST VIRGINIA ",
    Zipcode: 25702,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Stonewall Jackson Memorial Hospital",
    City: "Weston",
    State: "WEST VIRGINIA ",
    Zipcode: 26452,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Thomas Memorial Hospital",
    City: "Charleston",
    State: "WEST VIRGINIA ",
    Zipcode: 25309,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Jefferson Medical Center",
    City: "Ranson",
    State: "WEST VIRGINIA ",
    Zipcode: 25438,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Bellin Memorial Hospital",
    City: "Green Bay",
    State: "WISCONSIN ",
    Zipcode: 54301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Ascension SE Wisconsin Hospital - St. Joseph Campus",
    City: "Milwaukee",
    State: "WISCONSIN ",
    Zipcode: 53215,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Columbia St. Mary's Hospital Ozaukee",
    City: "Milwaukee",
    State: "WISCONSIN ",
    Zipcode: 53211,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Froedtert Memorial Lutheran Hospital",
    City: "Milwaukee",
    State: "WISCONSIN ",
    Zipcode: 53226,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Mary's Hospital",
    City: "Green Bay",
    State: "WISCONSIN ",
    Zipcode: 54303,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "The Froedtert & Medical college of Wisconsin",
    City: "Milwaukee",
    State: "WISCONSIN ",
    Zipcode: 54301,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Meriter Hospital Inc",
    City: "Madison",
    State: "WISCONSIN ",
    Zipcode: 53715,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "North Shore Surgery Center",
    City: "Pleasant Prairie",
    State: "WISCONSIN ",
    Zipcode: 53158,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Sauk Prairie Memorial Hospital",
    City: "Lodi",
    State: "WISCONSIN ",
    Zipcode: 53555,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Thedacare Regional Medical Center-appleton",
    City: "Appleton",
    State: "WISCONSIN ",
    Zipcode: 54911,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Wheaton Franciscan Healthcare",
    City: "Brookefield",
    State: "WISCONSIN ",
    Zipcode: 53045,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Froedtert Menomonee Falls Hospital",
    City: "Menomonee Falls",
    State: "WISCONSIN ",
    Zipcode: 53051,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Marshfield Medical Center",
    City: "Eau Claire",
    State: "WISCONSIN ",
    Zipcode: 54701,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "UW Health University Hospital",
    City: "Madison",
    State: "WISCONSIN ",
    Zipcode: 53792,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Sheridan Memorial Hospital",
    City: "Sheridan",
    State: "WYOMING",
    Zipcode: 82801,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Cheyenne Reg Medical Center ",
    City: "Cheyenne",
    State: "WYOMING",
    Zipcode: 82001,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 0,
  },
  {
    "Provider Name": "Evanston Regional Hospital",
    City: "Evanston",
    State: "WYOMING",
    Zipcode: 82930,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Powell Valley Healthcare",
    City: "Powell",
    State: "WYOMING",
    Zipcode: 82435,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Sagewest Health Care",
    City: "Riverton",
    State: "WYOMING",
    Zipcode: 82501,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Wyoming Medical Center",
    City: "Casper",
    State: "WYOMING",
    Zipcode: 82601,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Memorial Hospital of Converse Cnty",
    City: "Lander",
    State: "WYOMING",
    Zipcode: 82520,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Russell Medical Center",
    City: "Alexander City",
    State: "ALABAMA",
    Zipcode: 35010,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Tempe St. Lukes Hospital ",
    City: "TEMPE",
    State: "ARIZONA",
    Zipcode: 85281,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Vincent Medical Center North",
    City: "Little Rock",
    State: "ARKANSAS",
    Zipcode: 72117,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Nea Baptist Memorial Hospital",
    City: "Jonesboro",
    State: "ARKANSAS",
    Zipcode: 72117,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Northwest Medical Center",
    City: "Tucson",
    State: "ARIZONA",
    Zipcode: 85741,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Desert Regional Medical Center",
    City: "Palm Springs",
    State: "CALIFORNIA",
    Zipcode: 92262,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Loma Linda University Medical Center ",
    City: "Loma Linda ",
    State: "CALIFORNIA",
    Zipcode: 92354,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bayhealth Hospital-Kent Campus",
    City: "Dover",
    State: "DELAWARE",
    Zipcode: 19904,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Florida Medical Center",
    City: "Fort Lauderdale",
    State: "FLORIDA",
    Zipcode: 33313,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Presence Saint Joseph",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60435,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name":
      "CHI Saint Joseph Health - Saint Joseph Hospital - Emergency Room",
    City: "Fayette",
    State: "KENTUCKY",
    Zipcode: 40504,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Baptist Health Corbin",
    City: "Corbin",
    State: "KENTUCKY",
    Zipcode: 40701,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Chi Health St. Francis",
    City: "Grand Island",
    State: "NEBRASKA",
    Zipcode: 68803,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Bellevue Hospital ",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10016,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Stony Brook Southhampton",
    City: "Southhampton",
    State: "NEW YORK",
    Zipcode: 11968,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "ProMedica Memorial Hospital",
    City: "Fremont",
    State: "OHIO",
    Zipcode: 43420,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "ProMedica Defiance Regional Hospital",
    City: "Defiance",
    State: "OHIO",
    Zipcode: 43512,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "ProMedica Toledo Hospital",
    City: "Sylvania",
    State: "OHIO",
    Zipcode: 43560,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "SSM Health St. Anthony Hospital ",
    City: "Midwest City",
    State: "OKLAHOMA",
    Zipcode: 73110,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Providence Willamette Falls Medical Center",
    City: "Oregon City",
    State: "OREGON",
    Zipcode: 97045,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Shriners Hospitals For Children ",
    City: "Greenville",
    State: "SOUTH CAROLINA",
    Zipcode: 29605,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Medical City Plano ",
    City: "Plano ",
    State: "TEXAS",
    Zipcode: 75075,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Baylor Universtiy Medical Center ",
    City: "Dallas ",
    State: "TEXAS",
    Zipcode: 75246,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Medical City of Arlington",
    City: "Arlington",
    State: "TEXAS",
    Zipcode: 76015,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "HCAHouston Medical Center ",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77004,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "CHI St. Luke's Health",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77030,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "St. Lukes the Woodlands ",
    City: "The Woodlands",
    State: "TEXAS",
    Zipcode: 77384,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Christus St. Elizabeth",
    City: "Beaumont",
    State: "TEXAS",
    Zipcode: 77702,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Doctors Hosptial at Edinburg",
    City: "Edinburg",
    State: "TEXAS",
    Zipcode: 78539,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Ascension Seton Medical Center ",
    City: "Austin ",
    State: "TEXAS",
    Zipcode: 78705,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Swedish Health Services",
    City: "Seattle",
    State: "WASHINGTON",
    Zipcode: 98122,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Marshfield Medical Center ",
    City: "Eau Claire",
    State: "WISCONSIN",
    Zipcode: 54701,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 0,
  },
  {
    "Provider Name": "Cheyenne Reg Medical Center",
    City: "Cheyenne",
    State: "WYOMING",
    Zipcode: 82001,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "University of South Alabama Medical Center",
    City: "Mobile",
    State: "ALABAMA",
    Zipcode: 36617,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Maricopa Health System ",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85004,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Banner - University Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85006,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Banner Good Samaritan Medical Center",
    City: "Phoenix",
    State: "ARIZONA",
    Zipcode: 85006,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Scottsdale Healthcare Osborn Medical Center",
    City: "Scottsdale",
    State: "ARIZONA",
    Zipcode: 85251,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Scottsdale Healthcare Shea Medical Center",
    City: "Scottsdale",
    State: "ARIZONA",
    Zipcode: 85260,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Ozarks Community Hospital",
    City: "Gravette",
    State: "ARKANSAS",
    Zipcode: 72736,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Adventist Health White Memorial",
    City: "Los Angeles",
    State: "CALIFORNIA",
    Zipcode: 90033,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name":
      "Providence Little Company of Mary Medical Center-San Pedro",
    City: "San Pedro",
    State: "CALIFORNIA",
    Zipcode: 90732,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "USC Verdugo Hills Hospital",
    City: "Glendale",
    State: "CALIFORNIA",
    Zipcode: 91208,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Providence Saint Joseph Medical Center",
    City: "Burbank",
    State: "CALIFORNIA",
    Zipcode: 91505,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Saint Francis Memorial Hospital ",
    City: "San Francisco",
    State: "CALIFORNIA",
    Zipcode: 94109,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Saint Francis Hospital",
    City: "Hartford",
    State: "CONNECTICUT",
    Zipcode: 6105,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Orange Park Medical Center",
    City: "Orange Park",
    State: "FLORIDA",
    Zipcode: 32073,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Florida Hospital Memorial Medical Center",
    City: "Ormond Beach",
    State: "FLORIDA",
    Zipcode: 32117,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "UF Health Jacksonville",
    City: "Jacksonville",
    State: "FLORIDA",
    Zipcode: 32209,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Florida Hospital Apopka- AdventHealth",
    City: "Apopka",
    State: "FLORIDA",
    Zipcode: 32703,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Jackson Health System/ Holtz Children’s Hospital",
    City: "Miami",
    State: "FLORIDA",
    Zipcode: 33136,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Plantation General Hospital ",
    City: "Plantation",
    State: "FLORIDA",
    Zipcode: 33317,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "West Palm Hospital ",
    City: "West Palm Beach",
    State: "FLORIDA",
    Zipcode: 33470,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Moffitt Cancer Center",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33612,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Florida Hospital Tampa",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33613,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Kindred Hospital Bay Area - Tampa",
    City: "Tampa",
    State: "FLORIDA",
    Zipcode: 33705,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Fawcett Memorial Hospital ",
    City: "Port Charlotte",
    State: "FLORIDA",
    Zipcode: 33952,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Florida Hospital North Pinellas",
    City: "Tarpon Springs",
    State: "FLORIDA",
    Zipcode: 34689,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Ascencion Sacred Heart ",
    City: "Panama City ",
    State: "FLORIDA",
    Zipcode: 32401,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Bayfront Health",
    City: "Orlando",
    State: "FLORIDA",
    Zipcode: 33782,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Gwinnett Medical Center-Duluth",
    City: "Duluth",
    State: "GEORGIA",
    Zipcode: 30096,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "AMITA Health Saint Joseph Hospital Elgin",
    City: "Elgin",
    State: "ILLINOIS",
    Zipcode: 60123,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Presence Mercy Medical Center ",
    City: "Aurora",
    State: "ILLINOIS",
    Zipcode: 60506,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Presence Resurrection Medical Center ",
    City: "Chicago",
    State: "ILLINOIS",
    Zipcode: 60631,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "OSF Heart of Mary Medical Center",
    City: "Urbana",
    State: "ILLINOIS",
    Zipcode: 61832,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Presence United Samaritans Medical Center ",
    City: "Danville",
    State: "ILLINOIS",
    Zipcode: 61832,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "MercyOne Cedar Falls Medical Center ",
    City: "Cedar Falls",
    State: "IOWA",
    Zipcode: 50613,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Our Lady of The Lake Regional Medical Center",
    City: "Baton Rouge",
    State: "LOUISIANA",
    Zipcode: 70805,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Addison Gilbert Hospital - Beverly Hospital",
    City: "Gloucester",
    State: "MASSACHUSETTS",
    Zipcode: 1930,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Boston Medical Center ",
    City: "Boston",
    State: "MASSACHUSETTS",
    Zipcode: 2128,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "CHA Cambridge Hospital ",
    City: "Cambridge",
    State: "MASSACHUSETTS",
    Zipcode: 2139,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Beaumont Hospital-Grosse Pointe",
    City: "Grosse Pointe",
    State: "MICHIGAN",
    Zipcode: 48230,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Sunrise Hospital & Med Center",
    City: "Las Vegas",
    State: "NEVADA",
    Zipcode: 89109,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Bayonne Hospital ",
    City: "Bayonne",
    State: "NEW JERSEY",
    Zipcode: 7002,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Presbyterian Hospital",
    City: "Albuquerque",
    State: "NEW MEXICO",
    Zipcode: 87106,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "St. Luke’s Hospital–Roosevelt",
    City: "New York",
    State: "NEW YORK",
    Zipcode: 10025,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Brookhaven Memorial Hospital Medical Center",
    City: "Patchogue",
    State: "NEW YORK",
    Zipcode: 11772,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "St. Charles Hospital",
    City: "Port Jefferson",
    State: "NEW YORK",
    Zipcode: 11777,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Kettering Medical Center",
    City: "Dayton",
    State: "OHIO",
    Zipcode: 45429,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "University of Pittsburgh Medical Center ",
    City: "Pittsburgh",
    State: "PENNSYLVANIA",
    Zipcode: 15219,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Jefferson Methodist Hospital",
    City: "Philadelphia",
    State: "PENNSYLVANIA",
    Zipcode: 19148,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Penn State Health St. Joseph",
    City: "Reading",
    State: "PENNSYLVANIA",
    Zipcode: 19605,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "MUSC Health Chester Medical Center",
    City: "Charleston",
    State: "SOUTH CAROLINA ",
    Zipcode: 29574,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 1,
    Core: 1,
  },
  {
    "Provider Name": "Tristar Summit Medical Center",
    City: "Hermitage",
    State: "TENNESSEE",
    Zipcode: 37076,
    Country: "UNITED STATES",
    Ultra: 1,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "City Hospital at White Rock",
    City: "Dallas",
    State: "TEXAS",
    Zipcode: 75218,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Medical Center Dialys ",
    City: "Houston",
    State: "TEXAS",
    Zipcode: 77004,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Baptist Hospitals of Southeast Texas - Beaumont Campus",
    City: "Beaumont",
    State: "TEXAS",
    Zipcode: 77701,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Christus St. Elizabet ",
    City: "Beaumont",
    State: "TEXAS",
    Zipcode: 77702,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "CHRISTUS Spohn Hospital Alice",
    City: "Alice",
    State: "TEXAS",
    Zipcode: 78332,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Doctors Hospital At Edinburg",
    City: "Edinburg",
    State: "TEXAS",
    Zipcode: 78539,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Mission Regional Medical Center",
    City: "Mission",
    State: "TEXAS",
    Zipcode: 78572,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Cedar park Regional Medical Center",
    City: "Cedar Park",
    State: "TEXAS",
    Zipcode: 78613,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "CJW Medical Center",
    City: "Richmond",
    State: "VIRGINIA",
    Zipcode: 23225,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Maryview Medical Center- Norfolk",
    City: "Norfolk",
    State: "VIRGINIA",
    Zipcode: 23505,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Highline Medical Center",
    City: "Burien",
    State: "WASHINGTON",
    Zipcode: 98166,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
  {
    "Provider Name": "Ascension St. Francis Hospital",
    City: "Milwaukee",
    State: "WISCONSIN",
    Zipcode: 53215,
    Country: "UNITED STATES",
    Ultra: 0,
    Plus: 0,
    Core: 1,
  },
];
export const plans = [
  {
    name: "Superior Plan",
    maxLimit: "$15,000,000",
    bgColor: "bg-[#FFEBEB]",
    borderBottom: "border-[#ED1C2C]",
    arrow: "text-red-600",
    backgroundclr: "bg-[#ED1C2C]",
    learnMorebtnColor: "bg-[#ED1C2C]",
    learnMorebtnHoverColor: "hover:bg-[#FFEBEB]",
    learnMorebtnTextColor: "text-white",
    learnMorebtnHoverTextColor: "hover:text-[#ED1C2C]",
    comparebtnColor: "bg-[#FFEBEB]",
    comparebtnHoverColor: "hover:bg-[#ffffff]",
    comparebtnTextColor: "text-red-600",
    comparebtnHoverTextColor: "hover:text-[#ED1C2C]",
    learnMoreBorderColor: "border-red-600",
    compareBtnborderColor: "border-red-600",
    tickImg: redTick,
    benefits: [
      "Worldwide coverage",
      "Inpatient and Outpatient Care",
      "Emergency Care and Evacuation",
      "Organ Transplant",
      "Cancer Treatment",
      "Maternity",
      "Tubal Ligation and Vasectomy",
      "Refractive Surgery",
      "Podiatric and Surgical Treatments*",
      "Second Medical Opinion",
      "Telehealth Services",
      "Mental Health Coaching",
      "Funeral Expenses",
      "Hearing Aids",
      "Nutritionist",
      "Fertility treatments",
      "Eye Exams",
    ],
  },
  {
    name: "Optima Plan",
    maxLimit: "$10,000,000",
    bgColor: "bg-[#D1EAEC]",
    borderBottom: "border-[#187C85]",
    arrow: "text-[#148D9B]",
    backgroundclr: "bg-[#148D9B]",
    tickImg: greentick,
    learnMorebtnColor: "bg-[#148D9B]",
    learnMorebtnHoverColor: "hover:bg-[#D1EAEC]",
    learnMorebtnTextColor: "text-white",
    learnMorebtnHoverTextColor: "hover:text-[#148D9B]",
    comparebtnColor: "bg-[#D1EAEC]",
    comparebtnHoverColor: "hover:bg-[#148D9B]",
    comparebtnTextColor: "text-[#148D98]",
    comparebtnHoverTextColor: "hover:text-[#ffffff]",
    learnMoreBorderColor: "border-[#148D98]",
    compareBtnborderColor: "border-[#148D98]",
    benefits: [
      "Worldwide coverage",
      "Inpatient and Outpatient Care",
      "Emergency Care and Evacuation",
      "Organ Transplant",
      "Cancer Treatment",
      "Maternity",
      "Tubal Ligation and Vasectomy",
      "Refractive Surgery",
      "Podiatric and Surgical Treatments*",
      "Second Medical Opinion",
      "Telehealth Services",
      "Mental Health Coaching",
      "Funeral Expenses",
      "Hearing Aids",
      "Nutritionist",
    ],
  },
  {
    name: "Vital Plan",
    maxLimit: "$5,000,000",
    bgColor: "bg-white",
    borderBottom: "border-[#A7A7A7]",
    arrow: "text-[#818181]",
    backgroundclr: "hidden",
    learnMorebtnColor: "bg-[#DCDDDE]",
    learnMorebtnHoverColor: "hover:bg-[#ffffff]",
    learnMorebtnTextColor: "text-[#272525]",
    learnMorebtnHoverTextColor: "hover:text-[#272525]",
    comparebtnColor: "bg-[#ffffff]",
    comparebtnHoverColor: "hover:bg-[#818181]",
    comparebtnTextColor: "text-[#272525]",
    comparebtnHoverTextColor: "hover:text-white",
    learnMoreBorderColor: "border-[#DCDDDE]",
    compareBtnborderColor: "border-[#818181]",
    tickImg: greytick,
    benefits: [
      "Worldwide coverage",
      "Inpatient and Outpatient Care",
      "Emergency Care and Evacuation",
      "Organ Transplant",
      "Cancer Treatment",
      "Maternity",
      "Tubal Ligation and Vasectomy",
      "Refractive Surgery",
      "Podiatric and Surgical Treatments*",
      "Second Medical Opinion",
      "Telehealth Services",
      "Mental Health Coaching",
    ],
  },
];
